import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCInstaSites1(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 501.64 388.94">
            <defs>
                <linearGradient
                    id="linear-insta-sites"
                    x1="-931.643"
                    y1="0.5"
                    x2="-930.641"
                    y2="0.5"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stopColor="#f5928f" />
                    <stop offset="1" stopColor="#f8b2b1" />
                </linearGradient>
            </defs>
            <g id="InstaSites" transform="translate(-5.68 -65.01)">
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="250.82"
                    cy="56.58"
                    rx="250.82"
                    ry="56.58"
                    transform="translate(5.68 340.79)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M351.82,215.24c-.71,28.35-3,126.15-1.9,160.81a7,7,0,0,0,6.73,6.74c18.16.59,84.73,2.1,114.43.85a11.72,11.72,0,0,0,11.24-11.46c.61-29.76,2-113.46-1.26-151.81a9.57,9.57,0,0,0-8.58-8.71c-19.78-2-86.63-6.81-112.3-5.15A9,9,0,0,0,351.82,215.24Z"
                    fill="#707272"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M359.92,223.94c-1,22.88-4.06,99-3.08,127.17a8,8,0,0,0,7.49,7.68c16.93,1,74.66,3.17,99.49,1.19a9,9,0,0,0,8.21-8.45c1.26-23.35,4.87-94.24,3.94-122.08a8.8,8.8,0,0,0-8-8.46c-18.31-1.64-79.66-5.56-100.75-4.41a7.71,7.71,0,0,0-7.3,7.36Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M396.69,211.47h0a1.63,1.63,0,0,0,1.55,1.63c4.29.23,16.37.86,21.77,1.17a1.63,1.63,0,0,0,1.7-1.94v-.18a1.64,1.64,0,0,0-1.45-1.32,210.141,210.141,0,0,0-22-1,1.63,1.63,0,0,0-1.57,1.64Z"
                    fill="#555656"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M400.52,292.81l33.35,1.11-2.33-23.93-31.02-.71Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M437.85,294.05l26.03.87.2-24.19-28.57-.65Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M464.11,266.78l.21-25.34a5.76,5.76,0,0,0-5.4-5.81l-79.36-5a5.77,5.77,0,0,0-6.12,5.5l-1.27,28.52Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M396.57,269.19l-24.58-.56-1.04,23.19,25.62.86Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M370.78,295.77l-2.14,47.76a5.77,5.77,0,0,0,5.62,6l83.29,2.12a5.77,5.77,0,0,0,5.91-5.72l.39-47.08Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M221.67,315.56l-6.39,57.28h74.1l-9.65-57.28Z"
                    fill="#707272"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M97.19,174.42v131.2a19.9,19.9,0,0,0,19.387,19.89c47.923,1.24,215.513,4.23,261.133,3.56a14.63,14.63,0,0,0,14.41-14.23c.88-30.47,2.31-103.76-3-137.79a15.06,15.06,0,0,0-14.4-12.75c-40.13-1.3-217.79-5.37-263.39-4.3a14.46,14.46,0,0,0-14.14,14.42Z"
                    fill="#555656"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M105.42,173.78V298.43A11.54,11.54,0,0,0,116.78,310l254.36,3.14a11.22,11.22,0,0,0,11.39-11.18L383,178.39a8.19,8.19,0,0,0-8-8.23l-260.42-5.27a8.9,8.9,0,0,0-9.16,8.89Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M384.45,318.08h0l-279-4.76a.22.22,0,1,1,.01-.44l279,4.75a.23.23,0,0,1,.22.23.22.22,0,0,1-.23.22Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M247.69,323.88a3.13,3.13,0,1,1,3.12-3.12,3.13,3.13,0,0,1-3.12,3.12Zm0-5.8a2.68,2.68,0,1,0,2.68,2.68A2.68,2.68,0,0,0,247.69,318.08Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M187.45,299.55h-58a5.18,5.18,0,0,1-5.18-5.18V218.7a5.18,5.18,0,0,1,5.18-5.18H191.7a5.17,5.17,0,0,1,5.17,5.47l-4.25,75.67A5.18,5.18,0,0,1,187.45,299.55Z"
                    fill="#707272"
                    opacity="0.2"
                />
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M187.45,295.6h-1.34a.45.45,0,1,1,0-.89h1.34a.34.34,0,0,0,.31-.19.45.45,0,0,1,.6-.2.44.44,0,0,1,.2.59,1.23,1.23,0,0,1-1.11.69Zm-3.56,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89H175a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0H155a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0H146.1a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89H135a.45.45,0,0,1,0,.89Zm-4.45,0h-1.12a1.24,1.24,0,0,1-1.24-1.23v-1a.45.45,0,1,1,.89,0v1a.35.35,0,0,0,.35.34h1.12a.45.45,0,1,1,0,.89Zm57.81-2.6h0a.45.45,0,0,1-.42-.47l.13-2.22a.441.441,0,0,1,.88.05l-.12,2.22a.44.44,0,0,1-.47.42Zm-59.72-1.34a.45.45,0,0,1-.45-.45v-2.22a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.44.4Zm60-3.1h0a.44.44,0,0,1-.42-.46l.13-2.22a.441.441,0,1,1,.88.05L189,288.1a.44.44,0,0,1-.4.41Zm-60-1.35a.45.45,0,0,1-.45-.44V284.5a.45.45,0,1,1,.89,0v2.22a.44.44,0,0,1-.44.44Zm60.21-3.08h0a.45.45,0,0,1-.42-.47l.13-2.22a.441.441,0,1,1,.88.05l-.12,2.22a.46.46,0,0,1-.47.37Zm-60.21-1.36a.45.45,0,0,1-.45-.45V280.1a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.44.4Zm60.46-3.08h0a.45.45,0,0,1-.42-.47l.12-2.22a.45.45,0,0,1,.47-.42.43.43,0,0,1,.42.47l-.12,2.22a.45.45,0,0,1-.47.37Zm-60.46-1.37a.45.45,0,0,1-.45-.44v-2.22a.45.45,0,1,1,.89,0v2.22a.44.44,0,0,1-.44.39Zm60.71-3.07h0a.44.44,0,0,1-.42-.47l.12-2.22a.46.46,0,0,1,.47-.42.45.45,0,0,1,.42.47l-.12,2.22a.45.45,0,0,1-.47.37Zm-60.71-1.37a.45.45,0,0,1-.45-.45v-2.22a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.44.4Zm61-3.07h0a.44.44,0,0,1-.42-.47l.12-2.22a.46.46,0,0,1,.47-.42.45.45,0,0,1,.42.47l-.12,2.22a.45.45,0,0,1-.51.37Zm-61-1.38a.45.45,0,0,1-.45-.44v-2.23a.45.45,0,0,1,.89,0v2.23a.44.44,0,0,1-.44.39Zm61.21-3.06h0a.43.43,0,0,1-.42-.47l.12-2.22a.446.446,0,0,1,.89.05l-.12,2.22a.45.45,0,0,1-.47.37Zm-61.21-1.38a.45.45,0,0,1-.45-.45v-2.22a.45.45,0,1,1,.89,0v2.22a.45.45,0,0,1-.44.4Zm61.46-3.06h0a.43.43,0,0,1-.42-.46l.12-2.22a.45.45,0,0,1,.47-.42.44.44,0,0,1,.42.47l-.12,2.22a.45.45,0,0,1-.47.36Zm-61.46-1.39a.45.45,0,0,1-.45-.44v-2.23a.45.45,0,0,1,.89,0v2.23a.44.44,0,0,1-.44.39Zm61.71-3h0a.45.45,0,0,1-.42-.47l.12-2.22a.45.45,0,0,1,.47-.42.44.44,0,0,1,.42.47l-.12,2.22a.46.46,0,0,1-.47.33Zm-61.71-1.4a.45.45,0,0,1-.45-.45v-2.22a.45.45,0,1,1,.89,0v2.22a.45.45,0,0,1-.44.36Zm62-3h0a.45.45,0,0,1-.42-.47l.12-2.22a.45.45,0,0,1,.47-.42.44.44,0,0,1,.42.47l-.13,2.22a.43.43,0,0,1-.5.28Zm-62-1.41a.45.45,0,0,1-.45-.44v-2.23a.45.45,0,0,1,.89,0v2.23a.44.44,0,0,1-.44.31Zm62.21-3h0a.43.43,0,0,1-.42-.47l.12-2.22a.45.45,0,0,1,.47-.42.46.46,0,0,1,.42.47l-.13,2.22a.44.44,0,0,1-.46.26Zm-62.21-1.42a.44.44,0,0,1-.45-.44v-2.22a.45.45,0,1,1,.89,0v2.22a.44.44,0,0,1-.44.28Zm62.46-3h0a.43.43,0,0,1-.41-.47l.12-2.22a.45.45,0,0,1,.47-.42.46.46,0,0,1,.42.47l-.13,2.22a.44.44,0,0,1-.47.24Zm-62.46-1.42a.45.45,0,0,1-.45-.44V240a.45.45,0,0,1,.89,0v2.23a.44.44,0,0,1-.44.48Zm62.71-3h0a.43.43,0,0,1-.41-.47L191,237a.446.446,0,0,1,.89.05l-.13,2.22a.44.44,0,0,1-.42.42Zm-62.71-1.43a.44.44,0,0,1-.45-.44V235.6a.45.45,0,1,1,.89,0v2.22a.44.44,0,0,1-.44.44Zm63-3h0a.44.44,0,0,1-.42-.46l.13-2.22a.45.45,0,0,1,.89.05l-.13,2.22a.44.44,0,0,1-.51.2Zm-63-1.43a.45.45,0,0,1-.45-.45v-2.22a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.44.24Zm63.21-3h0a.46.46,0,0,1-.42-.47l.13-2.22a.45.45,0,0,1,.89.05l-.13,2.22a.45.45,0,0,1-.47.21Zm-63.21-1.45a.45.45,0,0,1-.45-.44v-2.22a.45.45,0,1,1,.89,0v2.22a.44.44,0,0,1-.44.23Zm63.46-3h0a.46.46,0,0,1-.42-.47l.13-2.22a.45.45,0,0,1,.89.05l-.13,2.22a.44.44,0,0,1-.47.22Zm-63.46-1.45a.45.45,0,0,1-.45-.45v-2.22a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.44.25Zm63.71-3h0a.45.45,0,0,1-.42-.47l.13-2.22a.45.45,0,0,1,.47-.42.46.46,0,0,1,.42.47l-.13,2.22a.44.44,0,0,1-.47.23Zm-63.71-1.46a.45.45,0,0,1-.45-.44V218.7a1.25,1.25,0,0,1,.7-1.11.45.45,0,1,1,.39.8.35.35,0,0,0-.2.31V220a.44.44,0,0,1-.44.48Zm62.67-2.12h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89H178a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H162.4a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0H158a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89H138a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Z"
                    fill="#707272"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M275.67,300h-2.22a.45.45,0,0,1,0-.89h2.22a4.75,4.75,0,0,0,1.9-.39.441.441,0,0,1,.35.81,5.569,5.569,0,0,1-2.25.47Zm-4.44,0H269a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89ZM249,300h-2.22a.45.45,0,1,1,0-.89H249a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0H229a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89ZM209,300h-.11a5.53,5.53,0,0,1-2.23-.46.443.443,0,0,1,.36-.81,4.77,4.77,0,0,0,1.87.38H209a.45.45,0,1,1,0,.89Zm-4-1.71a.47.47,0,0,1-.33-.14,5.7,5.7,0,0,1-1.19-2.08.441.441,0,0,1,.84-.27,4.8,4.8,0,0,0,1,1.75.418.418,0,0,1-.32.73Zm74.49,0a.45.45,0,0,1-.33-.74,4.82,4.82,0,0,0,1-1.76.44.44,0,0,1,.55-.29.43.43,0,0,1,.29.56,5.53,5.53,0,0,1-1.18,2.08.44.44,0,0,1-.29.13Zm-75.8-4.1h0a.43.43,0,0,1-.41-.47l.12-2.22a.446.446,0,0,1,.89.05l-.13,2.22a.44.44,0,0,1-.43.4Zm77.09,0a.44.44,0,0,1-.44-.42l-.14-2.21a.45.45,0,0,1,.89-.06l.13,2.22a.43.43,0,0,1-.41.47ZM204,289.73h0a.43.43,0,0,1-.41-.46l.12-2.22a.44.44,0,0,1,.47-.42.45.45,0,0,1,.42.47l-.13,2.22a.44.44,0,0,1-.47.41Zm76.57,0a.45.45,0,0,1-.44-.42l-.14-2.22a.45.45,0,1,1,.89-.05l.13,2.21a.43.43,0,0,1-.41.47Zm-76.32-4.42h0a.46.46,0,0,1-.42-.47l.13-2.22a.45.45,0,0,1,.89.05l-.13,2.22a.45.45,0,0,1-.49.41Zm76,0a.44.44,0,0,1-.44-.42l-.14-2.22a.446.446,0,0,1,.89-.05l.13,2.22a.44.44,0,0,1-.41.47Zm-75.8-4.42h0a.46.46,0,0,1-.42-.47l.13-2.22a.45.45,0,0,1,.89.05l-.13,2.22a.44.44,0,0,1-.44.39Zm75.53,0a.44.44,0,0,1-.44-.42l-.14-2.22a.45.45,0,0,1,.42-.47.46.46,0,0,1,.47.42l.13,2.22a.44.44,0,0,1-.41.47Zm-75.28-4.42h0a.45.45,0,0,1-.42-.47l.13-2.22a.45.45,0,0,1,.47-.42.46.46,0,0,1,.42.47l-.13,2.22a.44.44,0,0,1-.44.37Zm75,0a.45.45,0,0,1-.45-.41l-.13-2.22a.45.45,0,0,1,.89-.06l.13,2.22a.43.43,0,0,1-.41.47ZM205,272h0a.45.45,0,0,1-.42-.47l.13-2.22a.45.45,0,0,1,.47-.42.46.46,0,0,1,.42.47l-.13,2.22a.44.44,0,0,1-.47.42Zm74.49,0a.45.45,0,0,1-.45-.42l-.13-2.22a.45.45,0,1,1,.89-.05l.13,2.22a.45.45,0,0,1-.42.47Zm-74.24-4.43h0a.45.45,0,0,1-.42-.47l.13-2.22a.44.44,0,0,1,.47-.41.43.43,0,0,1,.41.46l-.12,2.22a.44.44,0,0,1-.49.39Zm74,0a.45.45,0,0,1-.45-.42l-.13-2.22a.44.44,0,0,1,.41-.47.45.45,0,0,1,.48.42l.13,2.22a.45.45,0,0,1-.42.47Zm-73.72-4.42h0a.44.44,0,0,1-.42-.46l.13-2.22a.44.44,0,0,1,.47-.42.43.43,0,0,1,.41.47l-.12,2.22a.45.45,0,0,1-.52.37Zm73.45,0a.45.45,0,0,1-.45-.41l-.13-2.22a.441.441,0,0,1,.88-.06l.14,2.22a.44.44,0,0,1-.42.47Zm-73.2-4.42h0a.46.46,0,0,1-.42-.47l.13-2.22a.44.44,0,0,1,.46-.42.43.43,0,0,1,.42.47l-.12,2.22a.45.45,0,0,1-.52.36Zm72.93,0a.46.46,0,0,1-.45-.42l-.13-2.22a.44.44,0,1,1,.88,0l.14,2.21a.44.44,0,0,1-.42.47ZM206,254.23h0a.45.45,0,0,1-.42-.47l.13-2.22a.441.441,0,1,1,.88.05l-.12,2.22a.45.45,0,0,1-.47.42Zm72.41,0a.45.45,0,0,1-.44-.42l-.13-2.22a.44.44,0,0,1,.41-.47.43.43,0,0,1,.47.42l.14,2.22a.45.45,0,0,1-.42.47Zm-72.16-4.43h0a.44.44,0,0,1-.42-.47l.12-2.22a.46.46,0,0,1,.47-.42.45.45,0,0,1,.42.47l-.12,2.22a.45.45,0,0,1-.5.41Zm71.89,0a.44.44,0,0,1-.44-.42l-.13-2.21a.441.441,0,1,1,.88-.06l.14,2.22a.45.45,0,0,1-.42.47Zm-71.64-4.43h0a.44.44,0,0,1-.42-.47l.12-2.22a.46.46,0,0,1,.47-.42.45.45,0,0,1,.42.47l-.12,2.22a.45.45,0,0,1-.5.4Zm71.37,0a.44.44,0,0,1-.44-.41l-.14-2.22a.45.45,0,0,1,.42-.47.43.43,0,0,1,.47.41l.14,2.22a.44.44,0,0,1-.42.47Zm-71.12-4.43h0a.44.44,0,0,1-.42-.47l.12-2.22a.44.44,0,0,1,.47-.41.43.43,0,0,1,.42.46l-.12,2.22a.45.45,0,0,1-.5.39Zm70.85,0a.44.44,0,0,1-.44-.42l-.14-2.22a.46.46,0,0,1,.42-.47.43.43,0,0,1,.47.42l.14,2.22a.46.46,0,0,1-.42.47ZM207,236.48h0a.43.43,0,0,1-.42-.46l.12-2.22a.45.45,0,0,1,.47-.42.44.44,0,0,1,.42.47l-.12,2.22a.46.46,0,0,1-.47.41Zm70.33,0a.44.44,0,0,1-.44-.42l-.14-2.22a.45.45,0,0,1,.42-.47.44.44,0,0,1,.47.42l.14,2.22a.46.46,0,0,1-.42.47ZM207.22,232h0a.45.45,0,0,1-.42-.47l.12-2.22a.45.45,0,0,1,.47-.42.44.44,0,0,1,.42.47l-.12,2.22A.46.46,0,0,1,207.22,232ZM277,232a.44.44,0,0,1-.44-.41l-.14-2.22a.45.45,0,0,1,.89-.06l.14,2.22a.45.45,0,0,1-.42.47Zm-69.56-4.43h0a.45.45,0,0,1-.42-.47l.12-2.22a.45.45,0,0,1,.47-.42.44.44,0,0,1,.42.47l-.12,2.22a.45.45,0,0,1-.44.45Zm69.29,0a.45.45,0,0,1-.44-.42l-.14-2.22a.45.45,0,1,1,.89-.05l.13,2.21a.45.45,0,0,1-.41.48Zm-69-4.44h0a.43.43,0,0,1-.42-.47l.12-2.22a.46.46,0,0,1,.47-.42.45.45,0,0,1,.42.47l-.13,2.22a.44.44,0,0,1-.47.45Zm68.77,0a.44.44,0,0,1-.44-.42l-.14-2.22a.45.45,0,0,1,.89-.05l.13,2.22a.44.44,0,0,1-.41.47Zm-.27-4.44a.43.43,0,0,1-.44-.41,4.78,4.78,0,0,0-.59-1.92.44.44,0,1,1,.8-.36,5.61,5.61,0,0,1,.7,2.29.44.44,0,0,1-.41.48Zm-68.25,0h0a.44.44,0,0,1-.41-.48,5.609,5.609,0,0,1,.7-2.29.443.443,0,0,1,.77.44,4.78,4.78,0,0,0-.59,1.92.43.43,0,0,1-.45.44ZM274.11,215a.42.42,0,0,1-.26-.08,4.76,4.76,0,0,0-1.84-.82.443.443,0,1,1,.17-.87,5.48,5.48,0,0,1,2.19,1,.45.45,0,0,1,.1.62A.44.44,0,0,1,274.11,215Zm-64,0a.44.44,0,0,1-.36-.18.45.45,0,0,1,.1-.62,5.54,5.54,0,0,1,2.19-1,.444.444,0,0,1,.18.87,4.74,4.74,0,0,0-1.85.82.42.42,0,0,1-.29.11Zm59.8-1h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89ZM261,214h-2.22a.45.45,0,1,1,0-.89H261a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H241a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H232.1a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H223.2a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89ZM221,214h-2.22a.45.45,0,1,1,0-.89H221a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Z"
                    fill="#707272"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M360,300h-2.23a.45.45,0,0,1,0-.89H360a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0H340a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0H331.1a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89ZM320,300h-2.22a.45.45,0,1,1,0-.89H320a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H300a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-.65a5.94,5.94,0,0,1-1.68-.25.45.45,0,0,1-.29-.56.43.43,0,0,1,.55-.29,4.829,4.829,0,0,0,1.42.21h.65a.45.45,0,1,1,0,.89Zm63.25-.1a.442.442,0,0,1-.09-.88,4.58,4.58,0,0,0,1.85-.81.444.444,0,1,1,.52.72,5.43,5.43,0,0,1-2.2,1Zm-67.36-1.23a.41.41,0,0,1-.3-.11,5.7,5.7,0,0,1-1.4-1.94.441.441,0,0,1,.81-.35,4.87,4.87,0,0,0,1.18,1.63.44.44,0,0,1,0,.63.43.43,0,0,1-.3.13Zm70.85-1.29a.45.45,0,0,1-.39-.67,4.64,4.64,0,0,0,.6-1.92.45.45,0,1,1,.89.07,5.529,5.529,0,0,1-.71,2.29.43.43,0,0,1-.4.22Zm-72.59-2.66a.44.44,0,0,1-.44-.41l-.14-2.22a.44.44,0,0,1,.42-.47.43.43,0,0,1,.47.41l.14,2.22a.45.45,0,0,1-.42.47ZM365.17,293a.45.45,0,0,1-.44-.45v-2.22a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.45.45Zm-73.53-2.76a.44.44,0,0,1-.44-.42l-.14-2.22a.45.45,0,0,1,.42-.47.44.44,0,0,1,.47.42l.14,2.22a.46.46,0,0,1-.42.47Zm73.53-1.69a.44.44,0,0,1-.44-.44v-2.22a.45.45,0,1,1,.89,0v2.22a.45.45,0,0,1-.45.48Zm-73.8-2.75a.44.44,0,0,1-.44-.42l-.14-2.22a.446.446,0,0,1,.89-.05l.13,2.22a.44.44,0,0,1-.41.47Zm73.8-1.69a.45.45,0,0,1-.44-.45v-2.22a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.45.49ZM291.1,281.4a.44.44,0,0,1-.44-.41l-.14-2.22a.45.45,0,0,1,.89-.06l.13,2.22a.43.43,0,0,1-.41.47Zm74.07-1.7a.44.44,0,0,1-.44-.44V277a.45.45,0,1,1,.89,0v2.22a.45.45,0,0,1-.45.48ZM290.83,277a.45.45,0,0,1-.44-.42l-.14-2.22a.45.45,0,1,1,.89-.05l.13,2.21a.43.43,0,0,1-.41.47Zm74.34-1.71a.45.45,0,0,1-.44-.45v-2.22a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.45.42Zm-74.61-2.73a.44.44,0,0,1-.44-.42l-.14-2.22a.446.446,0,1,1,.89-.05l.13,2.22a.44.44,0,0,1-.41.47Zm74.61-1.72a.44.44,0,0,1-.44-.44v-2.22a.45.45,0,1,1,.89,0v2.22a.45.45,0,0,1-.45.41Zm-74.88-2.72a.45.45,0,0,1-.45-.42l-.13-2.21a.446.446,0,1,1,.89-.06l.13,2.22a.43.43,0,0,1-.41.47Zm74.88-1.72a.45.45,0,0,1-.44-.45V263.7a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.45.45ZM290,263.65a.45.45,0,0,1-.45-.41l-.13-2.22a.45.45,0,0,1,.89-.06l.13,2.22a.43.43,0,0,1-.42.47Zm75.15-1.73a.44.44,0,0,1-.44-.44v-2.23a.45.45,0,0,1,.89,0v2.23a.45.45,0,0,1-.43.44Zm-75.42-2.7a.45.45,0,0,1-.45-.42l-.13-2.22a.45.45,0,1,1,.89-.05l.13,2.22a.45.45,0,0,1-.42.47Zm75.42-1.74a.45.45,0,0,1-.44-.45v-2.22a.45.45,0,1,1,.89,0V257a.45.45,0,0,1-.43.48Zm-75.69-2.7a.45.45,0,0,1-.45-.42l-.13-2.22a.44.44,0,0,1,.88,0l.14,2.22a.45.45,0,0,1-.42.47ZM365.17,253a.44.44,0,0,1-.44-.44v-2.23a.45.45,0,0,1,.89,0v2.23a.45.45,0,0,1-.45.44Zm-76-2.69a.45.45,0,0,1-.45-.41l-.13-2.22a.441.441,0,1,1,.88-.06l.14,2.22a.44.44,0,0,1-.42.47Zm76-1.75a.45.45,0,0,1-.44-.45v-2.22a.45.45,0,1,1,.89,0v2.22a.45.45,0,0,1-.45.48Zm-76.24-2.68a.45.45,0,0,1-.44-.42l-.13-2.22a.441.441,0,0,1,.88-.05l.14,2.21a.46.46,0,0,1-.42.48Zm76.24-1.77a.44.44,0,0,1-.44-.44v-2.23a.45.45,0,0,1,.89,0v2.23a.45.45,0,0,1-.45.47Zm-76.51-2.67a.45.45,0,0,1-.44-.42l-.13-2.22a.44.44,0,0,1,.41-.47.43.43,0,0,1,.47.42l.14,2.22a.45.45,0,0,1-.42.47Zm76.51-1.77a.45.45,0,0,1-.44-.45V237a.45.45,0,1,1,.89,0v2.22a.45.45,0,0,1-.45.48ZM288.39,237a.44.44,0,0,1-.44-.42l-.14-2.21a.45.45,0,0,1,.42-.47.43.43,0,0,1,.47.41l.14,2.22a.44.44,0,0,1-.42.47Zm76.78-1.78a.44.44,0,0,1-.44-.44v-2.23a.45.45,0,0,1,.89,0v2.23a.45.45,0,0,1-.45.47Zm-77.05-2.66a.44.44,0,0,1-.44-.41l-.14-2.22a.45.45,0,0,1,.42-.47.43.43,0,0,1,.47.41l.14,2.22a.44.44,0,0,1-.42.47Zm77.05-1.79a.44.44,0,0,1-.44-.44v-2.22a.45.45,0,1,1,.89,0v2.22a.44.44,0,0,1-.45.47Zm-77.32-2.64a.44.44,0,0,1-.44-.42l-.14-2.22a.45.45,0,0,1,.42-.47.43.43,0,0,1,.47.42l.14,2.22a.46.46,0,0,1-.42.47Zm77.32-1.8a.45.45,0,0,1-.44-.45v-2.22a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.45.48Zm-77.59-2.64a.44.44,0,0,1-.44-.42l-.14-2.22a.446.446,0,1,1,.89-.05l.14,2.22a.46.46,0,0,1-.42.47Zm77.59-1.81a.44.44,0,0,1-.44-.44v-2.22a.45.45,0,1,1,.89,0v2.22a.45.45,0,0,1-.45.47Zm-77.86-2.63a.44.44,0,0,1-.44-.43v-.15a5.52,5.52,0,0,1,.45-2.2.441.441,0,1,1,.81.35,4.67,4.67,0,0,0-.37,1.85v.13a.44.44,0,0,1-.43.45Zm77.6-1.78a.46.46,0,0,1-.43-.31,4.73,4.73,0,0,0-1-1.72.45.45,0,1,1,.65-.61,5.65,5.65,0,0,1,1.23,2,.45.45,0,0,1-.28.57ZM289,215.32a.44.44,0,0,1-.3-.77,5.47,5.47,0,0,1,2.07-1.2.443.443,0,0,1,.28.84,4.8,4.8,0,0,0-1.75,1,.42.42,0,0,1-.3.13Zm73-1a.51.51,0,0,1-.17,0A4.76,4.76,0,0,0,360,214h-.21a.45.45,0,1,1,0-.89H360a5.58,5.58,0,0,1,2.13.42.45.45,0,0,1,.24.58.44.44,0,0,1-.37.24Zm-4.4-.38h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H350.9a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H342a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0H337.6a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89ZM322,214h-2.22a.45.45,0,1,1,0-.89H322a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0H302a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Z"
                    fill="#707272"
                />
                <path
                    id="Path_18"
                    data-name="Path 18"
                    d="M305.35,384.56H196.89c-2.95,0-5.16-2.1-4.59-4.35l1.39-5.51c.42-1.65,2.24-2.87,4.41-2.93l104.55-3.27c2.26-.07,4.26,1.13,4.75,2.85l2.51,8.77C310.56,382.4,308.34,384.56,305.35,384.56Z"
                    fill="#555656"
                />
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M255.27,373.13a.225.225,0,0,1,0-.45l4.48-.06a.22.22,0,0,1,0,.44Z"
                    fill="#98b1dc"
                />
                <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M196.32,381.39h0a.22.22,0,0,1-.18-.25l.64-4a4.32,4.32,0,0,1,4.22-3.65l47.52-.7a.23.23,0,0,1,0,.45l-47.52.69a3.88,3.88,0,0,0-3.79,3.28l-.64,4a.22.22,0,0,1-.25.18Z"
                    fill="#98b1dc"
                />
                <g id="Group_1" data-name="Group 1" opacity="0.1">
                    <ellipse
                        id="Ellipse_1"
                        data-name="Ellipse 1"
                        cx="30.12"
                        cy="30.68"
                        rx="30.12"
                        ry="30.68"
                        transform="matrix(0.751, -0.66, 0.66, 0.751, 393.175, 298.495)"
                        fill="#555656"
                    />
                </g>
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M461.24,279.52c-12.44-14.16-33.8-15.75-47.71-3.53s-15.11,33.6-2.67,47.76,33.8,15.75,47.71,3.54S473.67,293.69,461.24,279.52Zm-46.68,41c-10.61-12.09-9.59-30.33,2.28-40.75s30.09-9.07,40.7,3,9.59,30.33-2.28,40.75-30.09,9.07-40.7-3.01Z"
                    fill="#555656"
                />
                <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M467.1,297.2a.12.12,0,0,1-.11-.09,32,32,0,0,0-7.57-16,31.57,31.57,0,0,0-34-9.25h0a30.24,30.24,0,0,0-5.88,2.74.11.11,0,0,1-.16,0,.13.13,0,0,1,0-.16,31.349,31.349,0,0,1,5.93-2.76h0a31.37,31.37,0,0,1,18.21-.62,32.39,32.39,0,0,1,23.64,26,.11.11,0,0,1-.09.13Zm-54.81-16.56a.09.09,0,0,1-.07-.16c.53-.59,1.08-1.18,1.66-1.74a.11.11,0,0,1,.16,0,.1.1,0,0,1,0,.15c-.57.56-1.12,1.14-1.65,1.73a.09.09,0,0,1-.1.02Z"
                    fill="#555656"
                />
                <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M435.51,333l-3.19,66a4.75,4.75,0,0,0,4.9,5h.45a4.42,4.42,0,0,0,4.29-4.58L439.56,333Z"
                    fill="#555656"
                />
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M437.15,402.73a2.811,2.811,0,0,1-1.06-.2,3.57,3.57,0,0,1-2.28-3.48l.21-8a.11.11,0,1,1,.22.01l-.21,8a3.38,3.38,0,0,0,2.13,3.28c1.3.48,2.6,0,3.88-1.43a.11.11,0,0,1,.15,0,.1.1,0,0,1,0,.15A4.2,4.2,0,0,1,437.15,402.73Z"
                    fill="#555656"
                />
                <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M434.19,388.69h0a.11.11,0,0,1-.11-.12v-1a.13.13,0,0,1,.12-.11.11.11,0,0,1,.11.11v1a.11.11,0,0,1-.12.12Z"
                    fill="#555656"
                />
                <path
                    id="Path_26"
                    data-name="Path 26"
                    d="M74.5,410.7l32.08-21.42a13.48,13.48,0,0,1,7.33-2.27c29.12-.36,208.65-2.36,250.19,2.05a10,10,0,0,1,5.45,2.36l22.5,19.28Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M75.32,413.43l-.82-2.73H392.05l-1.35,2.56a5.35,5.35,0,0,1-4.75,2.87h-307a3.77,3.77,0,0,1-3.63-2.7Z"
                    fill="#555656"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M94.43,403.85,111.35,392a8.92,8.92,0,0,1,5.16-1.62l239.3,1a13.3,13.3,0,0,1,8.71,3.29l8.84,7.74a1.79,1.79,0,0,1-1.17,3.14L95.47,407.11a1.79,1.79,0,0,1-1.04-3.26Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_29"
                    data-name="Path 29"
                    d="M363.74,394.77a4.179,4.179,0,0,0,.83,0s.41-.22,0-.47l-7.9-2.71a11.262,11.262,0,0,0-1.74-.16l-4.05-.48c-.48,0-.51.76-.2,1.13l1.71,2.08a2.14,2.14,0,0,0,1.44.67Z"
                    fill="#707272"
                />
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M349.27,397.23a2.1,2.1,0,0,0-1.43-.67l-14.72-.42c-.49,0-.5.78-.24,1.18l1.3,2a1.84,1.84,0,0,0,1.36.73h15.14c.48,0,.67-.72.36-1.09Z"
                    fill="#707272"
                />
                <path
                    id="Path_31"
                    data-name="Path 31"
                    d="M346.39,394.81c.48,0,.68-.7.37-1.07L345,392a2.15,2.15,0,0,0-1.44-.68l-13.88-.51c-.48,0-.53.78-.26,1.18l1.37,2.09a1.78,1.78,0,0,0,1.36.73Z"
                    fill="#707272"
                />
                <path
                    id="Path_32"
                    data-name="Path 32"
                    d="M308.55,397.42a1.58,1.58,0,0,0-1.28-.78l-12.55-.32c-.49,0-.54.72-.38,1.17l.65,1.8a1.36,1.36,0,0,0,1.18.82h12.88c.48,0,.74-.71.51-1.14Z"
                    fill="#707272"
                />
                <path
                    id="Path_33"
                    data-name="Path 33"
                    d="M327.64,397.33a1.84,1.84,0,0,0-1.36-.73l-12.53-.41c-.48,0-.49.79-.27,1.22l1,1.88a1.58,1.58,0,0,0,1.28.78h12.8c.48,0,.66-.79.4-1.19Z"
                    fill="#707272"
                />
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M269.38,395c.48,0,.81-.68.71-1.15l-.51-1.92a1.16,1.16,0,0,0-1.07-.86H255.75a.81.81,0,0,0-.83.87l.11,2.27a.92.92,0,0,0,.92.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M287.87,394.93c.48,0,.78-.69.62-1.14l-.83-1.86a1.35,1.35,0,0,0-1.17-.83l-12-.28c-.48,0-.51.62-.4,1.09l.48,2.19a1.13,1.13,0,0,0,1.07.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M306.36,394.89c.48,0,.73-.74.51-1.17L305.72,392a1.58,1.58,0,0,0-1.28-.78l-11.72-.36c-.48,0-.55.68-.38,1.13l.77,2.14a1.35,1.35,0,0,0,1.18.82Z"
                    fill="#707272"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M325.12,394.85c.49,0,.66-.79.4-1.2l-1.4-1.66a1.84,1.84,0,0,0-1.36-.74L311,390.82c-.48,0-.52.73-.3,1.16l1.1,2.12a1.57,1.57,0,0,0,1.28.77Z"
                    fill="#707272"
                />
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M270.83,397.57a1.13,1.13,0,0,0-1.06-.85H256.03a.82.82,0,0,0-.83.87l.08,1.7a.93.93,0,0,0,.92.87h14.33c.48,0,.81-.62.7-1.09Z"
                    fill="#707272"
                />
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M121.89,397.65c.33-.35.29-1.09-.19-1.09l-16.68.49a3.359,3.359,0,0,0-1.6.51l-3.5,2c-.4.27-.33,1,.15,1h18.24a2.39,2.39,0,0,0,1.49-.63Z"
                    fill="#707272"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M142.81,397.66c.3-.37.23-1.14-.25-1.14l-13.1.48a2.43,2.43,0,0,0-1.49.64l-2.09,1.72c-.33.35-.21,1.1.27,1.1h13.6a2.05,2.05,0,0,0,1.42-.69Z"
                    fill="#707272"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M249.8,395a.82.82,0,0,0,.83-.88l-.11-2.29a.94.94,0,0,0-.92-.88l-11.81-.05a1,1,0,0,0-1,.87l-.24,2.39a.78.78,0,0,0,.79.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M356.68,399.31a2.12,2.12,0,0,0,1.44.67h11.55a.52.52,0,0,0,.34-.91l-2.73-1.95a2.73,2.73,0,0,0-1.54-.58l-10.62-.37c-.49,0-.47.7-.16,1.07Z"
                    fill="#707272"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M208.21,397.69c.12-.47,0-1.17-.43-1.17l-16,.36a1.48,1.48,0,0,0-1.24.8l-.9,1.59a.75.75,0,0,0,.57,1.06h16.46a1.2,1.2,0,0,0,1.1-.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_44"
                    data-name="Path 44"
                    d="M231.83,397.67a.78.78,0,0,0-.79-.87H213.86a1.22,1.22,0,0,0-1.11.85l-.5,1.53a.85.85,0,0,0,.68,1.07h17.76a1,1,0,0,0,1-.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_45"
                    data-name="Path 45"
                    d="M250.8,397.63a.92.92,0,0,0-.92-.87H237.2a1,1,0,0,0-1,.88l-.17,1.7a.78.78,0,0,0,.79.87h13.19a.83.83,0,0,0,.84-.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_46"
                    data-name="Path 46"
                    d="M185.68,397.69c.19-.44.15-1.17-.34-1.17l-13.45.4a1.74,1.74,0,0,0-1.33.75l-1.21,1.67a.66.66,0,0,0,.46,1H183.6a1.49,1.49,0,0,0,1.24-.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_47"
                    data-name="Path 47"
                    d="M289.68,397.5a1.34,1.34,0,0,0-1.18-.82l-12.75-.21c-.49,0-.53.62-.43,1.09l.39,1.73a1.13,1.13,0,0,0,1.06.86h13c.48,0,.78-.68.62-1.13Z"
                    fill="#707272"
                />
                <path
                    id="Path_48"
                    data-name="Path 48"
                    d="M165.43,397.68c.25-.41.17-1.16-.31-1.16l-15.28.44a2,2,0,0,0-1.42.69l-1.65,1.62c-.29.38-.14,1.15.34,1.14h15.81a1.74,1.74,0,0,0,1.34-.75Z"
                    fill="#707272"
                />
                <path
                    id="Path_49"
                    data-name="Path 49"
                    d="M256.28,402a.83.83,0,0,0-.83.88l.12,2.51a.93.93,0,0,0,.92.87l15.35-.09c.49,0,.82-.64.71-1.11l-.57-2.24a1.13,1.13,0,0,0-1.07-.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_50"
                    data-name="Path 50"
                    d="M236.68,402a1,1,0,0,0-1,.87l-.26,2.59a.78.78,0,0,0,.79.87l14.09-.08a.84.84,0,0,0,.84-.88l-.12-2.53a.94.94,0,0,0-.92-.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_51"
                    data-name="Path 51"
                    d="M276.91,401.58c-.48,0-.54.71-.44,1.18l.55,2.48a1.13,1.13,0,0,0,1.07.85l13.79-.08c.48,0,.78-.67.62-1.13l-.94-2.18a1.34,1.34,0,0,0-1.17-.82Z"
                    fill="#707272"
                />
                <path
                    id="Path_52"
                    data-name="Path 52"
                    d="M231.21,395a1,1,0,0,0,1-.87l.24-2.42a.78.78,0,0,0-.79-.87l-16.15-.07a1.2,1.2,0,0,0-1.1.84l-.73,2.35c-.12.46.2,1.08.68,1.08Z"
                    fill="#707272"
                />
                <path
                    id="Path_53"
                    data-name="Path 53"
                    d="M316.47,401.49c-.48,0-.52.69-.3,1.11l1.29,2.49a1.57,1.57,0,0,0,1.28.77l13.58-.07c.48,0,.7-.72.44-1.12l-1.71-2.14a1.81,1.81,0,0,0-1.36-.73Z"
                    fill="#707272"
                />
                <path
                    id="Path_54"
                    data-name="Path 54"
                    d="M336.54,401.34c-.49,0-.51.77-.24,1.18l1.64,2.5a1.84,1.84,0,0,0,1.36.73l16.05-.09c.48,0,.67-.71.36-1.09l-2.15-2.14a2.07,2.07,0,0,0-1.43-.68Z"
                    fill="#707272"
                />
                <path
                    id="Path_55"
                    data-name="Path 55"
                    d="M373.5,402.83c-.29.1-1.35-1.12-1.83-1.12l-12.24-.42c-.48,0-.49.75-.19,1.12l2.09,2.53a2.11,2.11,0,0,0,1.44.68l8.54-.05a2.82,2.82,0,0,0,1.27-.38.92.92,0,0,0,.38-.47l.54-1.43C373.42,402.81,373.53,402.82,373.5,402.83Z"
                    fill="#707272"
                />
                <path
                    id="Path_56"
                    data-name="Path 56"
                    d="M296.67,401.42c-.48,0-.61.82-.45,1.27l.9,2.46a1.3,1.3,0,0,0,1.17.82l13.77-.07c.48,0,.73-.73.51-1.16l-1.33-2.13a1.6,1.6,0,0,0-1.28-.77Z"
                    fill="#707272"
                />
                <path
                    id="Path_57"
                    data-name="Path 57"
                    d="M186,395.13a1.46,1.46,0,0,0,1.23-.8l1.29-2.83c.2-.44.12-1.24-.36-1.24l-12.44.39a1.7,1.7,0,0,0-1.33.74l-1.89,2.71a.7.7,0,0,0,.5,1.06Z"
                    fill="#707272"
                />
                <path
                    id="Path_58"
                    data-name="Path 58"
                    d="M166.07,395.17a1.74,1.74,0,0,0,1.33-.75l1.84-3.05c.25-.41.24-1.11-.24-1.11l-14.1.3a2.09,2.09,0,0,0-1.42.68l-2.65,2.91c-.3.37-.09,1.06.4,1.05Z"
                    fill="#707272"
                />
                <path
                    id="Path_59"
                    data-name="Path 59"
                    d="M143.87,395.22a2.05,2.05,0,0,0,1.42-.69l2.62-3.31c.3-.38.31-1.12-.18-1.12l-12,.38a2.36,2.36,0,0,0-1.49.63l-3.42,3.13a.587.587,0,0,0,.34,1Z"
                    fill="#707272"
                />
                <path
                    id="Path_60"
                    data-name="Path 60"
                    d="M168.75,402.12a1.78,1.78,0,0,0-1.33.76L165.56,406c-.25.41-.06.75.42.74l72.93-.38a1.48,1.48,0,0,0,1.24-.8l1.33-2.93a.52.52,0,0,0-.52-.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_61"
                    data-name="Path 61"
                    d="M208,395.09a1.22,1.22,0,0,0,1.11-.85l.7-2.61c.12-.46,0-1.14-.44-1.14l-14.87.23a1.46,1.46,0,0,0-1.24.8L192,394c-.2.44.08,1.12.56,1.12Z"
                    fill="#707272"
                />
                <path
                    id="Path_62"
                    data-name="Path 62"
                    d="M123.3,395.26a2.39,2.39,0,0,0,1.48-.63l3.39-3.54c.34-.35.34-1.07-.15-1.07l-10.63.38a14.406,14.406,0,0,0-1.74.13l-3.52,1.1a12.584,12.584,0,0,0-1.5.89l-3.37,1.9a.47.47,0,0,0,.27.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_63"
                    data-name="Path 63"
                    d="M145.72,402.17a2,2,0,0,0-1.42.69l-2.61,3.3c-.3.38-.15.69.33.69l17.06-.1a1.72,1.72,0,0,0,1.33-.76l1.88-3.1c.25-.41.22-1.09-.26-1.09Z"
                    fill="#707272"
                />
                <path
                    id="Path_64"
                    data-name="Path 64"
                    d="M124.47,402.22a2.39,2.39,0,0,0-1.49.63l-3.33,3.49c-.34.35-.22.63.27.63l14.73-.08a2.11,2.11,0,0,0,1.42-.7l2.62-3.32c.3-.37.15-.68-.33-.68Z"
                    fill="#707272"
                />
                <path
                    id="Path_65"
                    data-name="Path 65"
                    d="M97.55,402.27a3.22,3.22,0,0,0-1.59.51l-1.43,1c-.33.23-.24.39-.26.72a1.44,1.44,0,0,0,0,.46l.28.85A1.79,1.79,0,0,0,95.81,407a2.14,2.14,0,0,0,.54.08l15.7-.09a2.37,2.37,0,0,0,1.49-.64l3.36-3.51c.33-.34.33-1.08-.16-1.08Z"
                    fill="#707272"
                />
                <path
                    id="Path_66"
                    data-name="Path 66"
                    d="M363.74,394.31a3.079,3.079,0,0,0,.83-.05l-.81-.49-7.09-2.68a12.659,12.659,0,0,0-1.74-.17H351c-.48,0-.63.3-.32.67l1.71,2.07a2.11,2.11,0,0,0,1.44.68Z"
                    fill="#707272"
                />
                <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M349.27,396.77a2.1,2.1,0,0,0-1.43-.67H333.28c-.49,0-.66.33-.4.73l1.3,2a1.84,1.84,0,0,0,1.36.73h15.14c.48,0,.63-.31.32-.68Z"
                    fill="#707272"
                />
                <path
                    id="Path_68"
                    data-name="Path 68"
                    d="M346.39,394.34c.48,0,.63-.3.32-.67L345,391.56a2.11,2.11,0,0,0-1.44-.68l-13.75-.06c-.48,0-.66.33-.39.73l1.37,2.09a1.81,1.81,0,0,0,1.36.73Z"
                    fill="#707272"
                />
                <path
                    id="Path_69"
                    data-name="Path 69"
                    d="M308.55,397a1.58,1.58,0,0,0-1.28-.78H294.92a.59.59,0,0,0-.58.83l.65,1.8a1.36,1.36,0,0,0,1.18.82h12.88a.49.49,0,0,0,.47-.78Z"
                    fill="#707272"
                />
                <path
                    id="Path_70"
                    data-name="Path 70"
                    d="M327.64,396.87a1.84,1.84,0,0,0-1.36-.73H313.96a.49.49,0,0,0-.48.78l1,1.88a1.58,1.58,0,0,0,1.28.78h12.8c.48,0,.66-.33.4-.73Z"
                    fill="#707272"
                />
                <path
                    id="Path_71"
                    data-name="Path 71"
                    d="M269.38,394.5a.68.68,0,0,0,.69-.86l-.49-2.21a1.16,1.16,0,0,0-1.07-.86l-12.76-.06a.83.83,0,0,0-.83.88l.11,2.26a.92.92,0,0,0,.92.88Z"
                    fill="#707272"
                />
                <path
                    id="Path_72"
                    data-name="Path 72"
                    d="M287.87,394.46a.58.58,0,0,0,.58-.82l-.79-2.17a1.35,1.35,0,0,0-1.17-.83l-11.73-.05a.67.67,0,0,0-.68.86l.48,2.18a1.14,1.14,0,0,0,1.07.86Z"
                    fill="#707272"
                />
                <path
                    id="Path_73"
                    data-name="Path 73"
                    d="M306.36,394.43a.5.5,0,0,0,.47-.79l-1.11-2.14a1.58,1.58,0,0,0-1.28-.78l-11.52-.05a.57.57,0,0,0-.58.82l.77,2.14a1.35,1.35,0,0,0,1.18.82Z"
                    fill="#707272"
                />
                <path
                    id="Path_74"
                    data-name="Path 74"
                    d="M325.12,394.39c.49,0,.66-.33.4-.74l-1.4-2.12a1.8,1.8,0,0,0-1.36-.74l-11.61-.05a.49.49,0,0,0-.48.78l1.1,2.11a1.58,1.58,0,0,0,1.28.78Z"
                    fill="#707272"
                />
                <path
                    id="Path_75"
                    data-name="Path 75"
                    d="M270.83,397.11a1.13,1.13,0,0,0-1.06-.85H256.03a.83.83,0,0,0-.83.88l.08,1.7a.93.93,0,0,0,.92.87h14.33a.68.68,0,0,0,.69-.86Z"
                    fill="#707272"
                />
                <path
                    id="Path_76"
                    data-name="Path 76"
                    d="M121.89,397.19c.33-.35.21-.63-.27-.63h-16.6a3.25,3.25,0,0,0-1.6.51l-3.5,2.45c-.4.27-.33.5.15.5h18.24a2.44,2.44,0,0,0,1.49-.63Z"
                    fill="#707272"
                />
                <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M142.81,397.2c.3-.38.15-.68-.33-.68h-13a2.37,2.37,0,0,0-1.49.64l-2.09,2.18c-.33.35-.21.64.27.64h13.6a2.05,2.05,0,0,0,1.42-.69Z"
                    fill="#707272"
                />
                <path
                    id="Path_78"
                    data-name="Path 78"
                    d="M249.8,394.54a.82.82,0,0,0,.83-.88l-.11-2.29a.94.94,0,0,0-.92-.88l-11.81-.05a1,1,0,0,0-1,.87l-.24,2.39a.78.78,0,0,0,.79.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_79"
                    data-name="Path 79"
                    d="M356.68,398.85a2.12,2.12,0,0,0,1.44.67h11.55c.48,0,.58-.26.22-.58l-2.61-2.28a2.73,2.73,0,0,0-1.54-.58H355.27c-.48,0-.62.31-.31.68Z"
                    fill="#707272"
                />
                <path
                    id="Path_80"
                    data-name="Path 80"
                    d="M208.21,397.23a.64.64,0,0,0-.65-.85H191.74a1.48,1.48,0,0,0-1.24.8l-.84,1.85a.52.52,0,0,0,.51.8h16.46a1.2,1.2,0,0,0,1.1-.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_81"
                    data-name="Path 81"
                    d="M231.83,397.21a.77.77,0,0,0-.79-.87H213.86a1.22,1.22,0,0,0-1.11.85l-.47,1.75a.64.64,0,0,0,.65.85h17.76a1,1,0,0,0,1-.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_82"
                    data-name="Path 82"
                    d="M250.8,397.17a.92.92,0,0,0-.92-.87H237.2a1,1,0,0,0-1,.88l-.17,1.7a.78.78,0,0,0,.79.87h13.19a.84.84,0,0,0,.84-.88Z"
                    fill="#707272"
                />
                <path
                    id="Path_83"
                    data-name="Path 83"
                    d="M185.68,397.23a.53.53,0,0,0-.52-.8H171.89a1.74,1.74,0,0,0-1.33.75l-1.17,2c-.25.41-.06.75.42.75H183.6a1.49,1.49,0,0,0,1.24-.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_84"
                    data-name="Path 84"
                    d="M289.68,397a1.34,1.34,0,0,0-1.18-.82H276.01a.68.68,0,0,0-.69.86l.39,1.73a1.14,1.14,0,0,0,1.06.86h13a.58.58,0,0,0,.58-.83Z"
                    fill="#707272"
                />
                <path
                    id="Path_85"
                    data-name="Path 85"
                    d="M165.43,397.22c.25-.41.06-.75-.42-.75H149.84a2,2,0,0,0-1.42.69l-1.65,2.08c-.29.38-.14.68.34.68h15.81a1.74,1.74,0,0,0,1.34-.75Z"
                    fill="#707272"
                />
                <path
                    id="Path_86"
                    data-name="Path 86"
                    d="M256.28,401.49a.83.83,0,0,0-.83.87l.12,2.51a.93.93,0,0,0,.92.88l15.35-.09a.67.67,0,0,0,.69-.86l-.55-2.49a1.12,1.12,0,0,0-1.07-.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_87"
                    data-name="Path 87"
                    d="M277.16,401.44a.68.68,0,0,0-.69.86l.55,2.47a1.13,1.13,0,0,0,1.07.86l13.79-.08a.58.58,0,0,0,.58-.83l-.9-2.48a1.32,1.32,0,0,0-1.17-.82Z"
                    fill="#707272"
                />
                <path
                    id="Path_88"
                    data-name="Path 88"
                    d="M231.21,394.58a1,1,0,0,0,1-.88l.24-2.41a.79.79,0,0,0-.79-.88l-16.15-.06a1.2,1.2,0,0,0-1.1.84l-.7,2.58a.64.64,0,0,0,.65.84Z"
                    fill="#707272"
                />
                <path
                    id="Path_89"
                    data-name="Path 89"
                    d="M316.65,401.36a.49.49,0,0,0-.48.78l1.29,2.48a1.58,1.58,0,0,0,1.28.78l13.58-.08c.48,0,.66-.33.39-.73l-1.66-2.52a1.75,1.75,0,0,0-1.36-.73Z"
                    fill="#707272"
                />
                <path
                    id="Path_90"
                    data-name="Path 90"
                    d="M336.69,401.32c-.48,0-.66.33-.39.74l1.64,2.5a1.8,1.8,0,0,0,1.36.72l16.05-.08c.48,0,.63-.31.32-.69L353.56,402a2.1,2.1,0,0,0-1.43-.67Z"
                    fill="#707272"
                />
                <path
                    id="Path_91"
                    data-name="Path 91"
                    d="M373,401.6a2.41,2.41,0,0,0-1.29-.35H359.6c-.48,0-.62.31-.32.68l2.09,2.53a2.1,2.1,0,0,0,1.44.67h8.54a3,3,0,0,0,1.17-.33,1.06,1.06,0,0,0,.5-.58l.52-1.37a2.51,2.51,0,0,0-.54-1.25Z"
                    fill="#707272"
                />
                <path
                    id="Path_92"
                    data-name="Path 92"
                    d="M189.38,401.62a1.49,1.49,0,0,0-1.24.8l-1.32,2.92a.52.52,0,0,0,.52.79L205,406a1.21,1.21,0,0,0,1.11-.85l.74-2.75a.64.64,0,0,0-.65-.84Z"
                    fill="#707272"
                />
                <path
                    id="Path_93"
                    data-name="Path 93"
                    d="M296.8,401.4a.58.58,0,0,0-.58.83l.9,2.46a1.3,1.3,0,0,0,1.17.82l13.77-.07a.5.5,0,0,0,.47-.79l-1.29-2.5a1.55,1.55,0,0,0-1.28-.77Z"
                    fill="#707272"
                />
                <path
                    id="Path_94"
                    data-name="Path 94"
                    d="M186,394.67a1.46,1.46,0,0,0,1.23-.8l1.29-2.83a.53.53,0,0,0-.52-.81l-12.28-.05a1.74,1.74,0,0,0-1.33.75l-1.82,3c-.25.41-.06.75.43.75Z"
                    fill="#707272"
                />
                <path
                    id="Path_95"
                    data-name="Path 95"
                    d="M166.07,394.71a1.74,1.74,0,0,0,1.33-.75l1.84-3c.25-.41.06-.75-.42-.75l-13.92-.06a2,2,0,0,0-1.42.68l-2.59,3.28c-.3.37-.15.68.34.68Z"
                    fill="#707272"
                />
                <path
                    id="Path_96"
                    data-name="Path 96"
                    d="M143.87,394.76a2.05,2.05,0,0,0,1.42-.69l2.62-3.31c.3-.38.15-.69-.34-.69L135.71,390a2.36,2.36,0,0,0-1.49.63l-3.35,3.5c-.33.35-.21.63.27.63Z"
                    fill="#707272"
                />
                <path
                    id="Path_97"
                    data-name="Path 97"
                    d="M251.18,404.9l-.12-2.53a.94.94,0,0,0-.92-.87H236.68a.832.832,0,0,0-.22,0l-67.71.1a1.75,1.75,0,0,0-1.33.76l-1.86,3.08c-.25.42-.06.75.42.75l84-.36a1.7,1.7,0,0,0,.44-.12.84.84,0,0,0,.76-.81Z"
                    fill="#707272"
                />
                <path
                    id="Path_98"
                    data-name="Path 98"
                    d="M208,394.63a1.24,1.24,0,0,0,1.11-.85l.7-2.61a.65.65,0,0,0-.65-.85l-14.66-.06a1.46,1.46,0,0,0-1.24.8l-1.27,2.8a.52.52,0,0,0,.51.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_99"
                    data-name="Path 99"
                    d="M123.3,394.8a2.35,2.35,0,0,0,1.48-.64l3.39-3.54c.34-.34.21-.63-.27-.63l-10.51-.05a14.4,14.4,0,0,0-1.74.13l-3.52,1.1a12.587,12.587,0,0,0-1.5.89l-3.25,2.27c-.4.28-.33.5.15.5Z"
                    fill="#707272"
                />
                <path
                    id="Path_100"
                    data-name="Path 100"
                    d="M145.72,401.71a2,2,0,0,0-1.42.69l-2.61,3.3c-.3.38-.15.69.33.68l17.06-.09a1.72,1.72,0,0,0,1.33-.76l1.88-3.1c.25-.42.06-.75-.43-.75Z"
                    fill="#707272"
                />
                <path
                    id="Path_101"
                    data-name="Path 101"
                    d="M124.47,401.75a2.45,2.45,0,0,0-1.49.64l-3.33,3.49c-.34.35-.22.63.27.63l14.73-.08a2.11,2.11,0,0,0,1.42-.7l2.62-3.32c.3-.38.15-.68-.33-.68Z"
                    fill="#707272"
                />
                <path
                    id="Path_102"
                    data-name="Path 102"
                    d="M97.56,401.81a3.35,3.35,0,0,0-1.6.5l-.81.57a2.79,2.79,0,0,0-.81,1.05.89.89,0,0,0,0,.58l.24.78A1.9,1.9,0,0,0,96,406.6a1.452,1.452,0,0,0,.35,0l15.7-.09a2.37,2.37,0,0,0,1.49-.64l3.36-3.51c.33-.35.21-.63-.27-.63Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="5.14"
                    cy="5.14"
                    r="5.14"
                    transform="translate(227.42 218.25)"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="5.14"
                    cy="5.14"
                    r="5.14"
                    transform="translate(229.38 125.8)"
                    fill="#fff"
                />
                <path
                    id="Path_103"
                    data-name="Path 103"
                    d="M336.67,311.8c2,.18,5.57.46,8.35.58a8,8,0,0,0,3.19-.31v.18a.58.58,0,0,1-.55.54,96.223,96.223,0,0,1-10.93,0,.41.41,0,0,1-.34-.61,4.717,4.717,0,0,1,.28-.38Z"
                    fill="#555656"
                />
                <path
                    id="Path_104"
                    data-name="Path 104"
                    d="M345,312.38c-2.78-.12-6.31-.4-8.35-.58,2-2.45,8.35-4.11,8.35-4.11h1.79a7.5,7.5,0,0,1,1.4,4.38A8,8,0,0,1,345,312.38Z"
                    fill="#707272"
                />
                <path
                    id="Path_105"
                    data-name="Path 105"
                    d="M347.11,304.76l-.16,3.32a.77.77,0,0,1-.65.72,3,3,0,0,1-1.35-.11.91.91,0,0,1-.6-.69l-.58-3.24Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_106"
                    data-name="Path 106"
                    d="M370.41,312.36a1.59,1.59,0,0,0,1.44-1.07h0a1.15,1.15,0,0,1-.78,1.31,4.9,4.9,0,0,1-2.13.33,2.11,2.11,0,0,1-1.61-.74h0a5.42,5.42,0,0,0,3.08.17Z"
                    fill="#555656"
                />
                <path
                    id="Path_107"
                    data-name="Path 107"
                    d="M366.25,304.74h1.47c2.26,0,3.67,4.71,4.13,6.55a1.59,1.59,0,0,1-1.44,1.07,5.42,5.42,0,0,1-3.07-.16,14.079,14.079,0,0,1-2.11-5.32,1.87,1.87,0,0,1,1.02-2.14Z"
                    fill="#707272"
                />
                <path
                    id="Path_108"
                    data-name="Path 108"
                    d="M367.53,301.66l.83,3.27a.89.89,0,0,1-.47,1,3.11,3.11,0,0,1-1.7.41.73.73,0,0,1-.6-.49l-1.21-3.44Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_109"
                    data-name="Path 109"
                    d="M368.51,302.6c-1,.91-4.34,1-4.34,1-12-28.73-16.87-32.81-16.87-32.81,1.73,10.84.28,34.85.28,34.85a7.19,7.19,0,0,1-4.52,0A185.251,185.251,0,0,0,337,260.23c8.09-.18,12.39-3,13.79-4.06C357.49,267,368.51,302.6,368.51,302.6Z"
                    fill="#707272"
                />
                <path
                    id="Path_110"
                    data-name="Path 110"
                    d="M348.69,223.13c1.53,7.64,1,21.31.62,27.55-.1,1.75,1.12,4.18,2.11,5.84a.51.51,0,0,1-.21.73,35.889,35.889,0,0,1-13.76,3.81.92.92,0,0,1-.94-.69,181.157,181.157,0,0,0-10.42-29.51C332.28,221,348.69,223.13,348.69,223.13Z"
                    fill="#555656"
                />
                <path
                    id="Path_111"
                    data-name="Path 111"
                    d="M346.49,271a.34.34,0,0,0,.19-.05.38.38,0,0,0,.13-.53,12,12,0,0,0-4.74-4.12.38.38,0,0,0-.51.18.37.37,0,0,0,.17.51,11.61,11.61,0,0,1,4.43,3.83.38.38,0,0,0,.33.18Z"
                    fill="#555656"
                />
                <path
                    id="Path_112"
                    data-name="Path 112"
                    d="M358.29,245.05a26.19,26.19,0,0,1-4.85,11.56l-1.1-.9a34.279,34.279,0,0,0,.55-11.05,13.161,13.161,0,0,1,5.4.39Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_113"
                    data-name="Path 113"
                    d="M347,232.56l1.71-9.43s11.43,8.74,9.6,21.92a13.16,13.16,0,0,0-5.4-.39C352.37,240.43,350.8,235.84,347,232.56Z"
                    fill="#555656"
                />
                <path
                    id="Path_114"
                    data-name="Path 114"
                    d="M326.09,230.86l4.41,9.5c-.71,5.74-3.79,8.22-7.11,9.17a20,20,0,0,0-1.49-6.19C326.15,239,326.09,230.86,326.09,230.86Z"
                    fill="#555656"
                />
                <path
                    id="Path_115"
                    data-name="Path 115"
                    d="M321.9,243.34a20,20,0,0,1,1.49,6.19c-8.87,3.44-11.21-3.23-11.21-3.23l1.64-.29A9.27,9.27,0,0,0,321.9,243.34Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_116"
                    data-name="Path 116"
                    d="M330.16,219.13l2.13,7.83a1.51,1.51,0,0,0,2,1,29.062,29.062,0,0,0,3.07-1.4,2.05,2.05,0,0,0,.73-2.95l-4.43-6.6Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_117"
                    data-name="Path 117"
                    d="M325.5,213.18c0,.14,1.77,8.94,1.77,8.94l5-1.13-.47-8.6S325.82,210.93,325.5,213.18Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_118"
                    data-name="Path 118"
                    d="M330.69,214.31l.6,4.5a.914.914,0,0,1,0,.17c0,.36-.31,1.56-1.52,1.22a5.66,5.66,0,0,0-2.81-.37.64.64,0,0,0-.44.73,27.833,27.833,0,0,0,1.16,4.1.62.62,0,0,0,.76.38,20.46,20.46,0,0,0,4.41-1.81.64.64,0,0,0,.31-.57c0-1.14-.18-4.59-.07-5.56s1.22-1.46,1.71-1.65a.63.63,0,0,0,.35-.35,1.65,1.65,0,0,0-1.11-2.4.64.64,0,0,1-.4-.82,1.65,1.65,0,0,0-.93-2.28,2.32,2.32,0,0,0-2.77.67.64.64,0,0,1-.81.1.48.48,0,0,0-.57,0,.63.63,0,0,1-.89-.27,1.89,1.89,0,0,0-2.2-1.1c-2.24.38-2.49,2.87-1.9,4.32s3,.91,4.2.17a2.72,2.72,0,0,1,2.63.34A.67.67,0,0,1,330.69,214.31Z"
                    fill="#555656"
                />
                <path
                    id="Path_119"
                    data-name="Path 119"
                    d="M333.28,218.74s-.92-2.58,0-3.21,2.35-.31,2,1.56C335,219.42,333.28,218.74,333.28,218.74Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_120"
                    data-name="Path 120"
                    d="M312.84,247.52c-.45.35-2-.38-2.91-.89a1.06,1.06,0,0,1-.52-1.27c.22-.71.6-1.62,1.06-1.74C311.23,243.43,314.67,246.08,312.84,247.52Z"
                    fill="url(#linear-insta-sites)"
                />
                <path
                    id="Path_121"
                    data-name="Path 121"
                    d="M388.09,269.07,271.38,227.56l-6.18,17.16,116.68,42.67a5.45,5.45,0,0,0,6.57-2.38,23.16,23.16,0,0,0,2.74-11.49,4.66,4.66,0,0,0-3.1-4.45Z"
                    fill="#707272"
                />
                <path
                    id="Path_122"
                    data-name="Path 122"
                    d="M235.27,223.13l16.12,2a14.16,14.16,0,0,1-3.2,8.38l-13.47-8.88a.81.81,0,0,1,.55-1.5Z"
                    fill="#707272"
                />
                <path
                    id="Path_123"
                    data-name="Path 123"
                    d="M271.38,227.56a22.47,22.47,0,0,1-6.18,17.16l-17-11.23a14.16,14.16,0,0,0,3.2-8.38Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_124"
                    data-name="Path 124"
                    d="M386.64,274.33a.35.35,0,0,0,.33-.23.34.34,0,0,0-.21-.43L275.09,234.2a.343.343,0,1,0-.22.65l111.66,39.46A.23.23,0,0,0,386.64,274.33Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_125"
                    data-name="Path 125"
                    d="M384.72,281.06a.34.34,0,0,0,.32-.23.33.33,0,0,0-.21-.43L273.17,240.93a.345.345,0,1,0-.23.65L384.6,281A.249.249,0,0,0,384.72,281.06Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_126"
                    data-name="Path 126"
                    d="M352.79,255.56l-5.16-.42-2.23,2.06s.53.73,2.18.31a24,24,0,0,1,3.92-.53s2.28,1,2.31-.89Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_127"
                    data-name="Path 127"
                    d="M231.11,224.67h-2.22a.44.44,0,0,1,0-.88h2.22a.44.44,0,0,1,0,.88Zm-4.45,0h-2.22a.44.44,0,1,1,0-.88h2.22a.44.44,0,0,1,0,.88Zm-4.44,0H220a.44.44,0,1,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm-4.45,0h-2.22a.44.44,0,0,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm-4.44,0h-2.22a.44.44,0,0,1,0-.88h2.22a.44.44,0,0,1,0,.88Zm-4.45,0h-2.22a.44.44,0,0,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm-4.44,0h-2.23a.44.44,0,0,1,0-.88h2.23a.44.44,0,1,1,0,.88Zm-4.45,0h-2.22a.44.44,0,1,1,0-.88H200a.44.44,0,0,1,0,.88Zm-4.44,0h-2.23a.44.44,0,0,1,0-.88h2.23a.44.44,0,1,1,0,.88Zm-4.45,0h-2.22a.44.44,0,0,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm-4.44,0h-2.23a.44.44,0,0,1,0-.88h2.23a.44.44,0,1,1,0,.88Zm-4.45,0H180a.44.44,0,1,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm-4.44,0h-2.23a.44.44,0,0,1,0-.88h2.23a.44.44,0,1,1,0,.88Zm-4.45,0H171.1a.44.44,0,1,1,0-.88h2.22a.44.44,0,0,1,0,.88Zm-4.45,0h-2.22a.44.44,0,1,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm-4.44,0h-2.22a.44.44,0,0,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm-4.45,0h-2.22a.44.44,0,1,1,0-.88H160a.44.44,0,0,1,0,.88Zm-4.44,0h-2.22a.44.44,0,0,1,0-.88h2.22a.44.44,0,0,1,0,.88Zm-4.45,0h-2.22a.44.44,0,0,1,0-.88h2.22a.44.44,0,0,1,0,.88Zm-4.44,0h-2.22a.44.44,0,1,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm-4.45,0H140a.44.44,0,1,1,0-.88h2.22a.44.44,0,1,1,0,.88Zm90.37-.77h0a.44.44,0,0,1-.43-.45v-2.22a.45.45,0,0,1,.45-.44h0a.44.44,0,0,1,.44.45v2.23A.45.45,0,0,1,232.57,223.9Zm.09-4.44h0a.45.45,0,0,1-.44-.46v-2.22a.44.44,0,0,1,.44-.43h0a.44.44,0,0,1,.44.45V219a.44.44,0,0,1-.44.46Zm.08-4.45h0a.44.44,0,0,1-.44-.45v-2.22a.45.45,0,0,1,.46-.44.44.44,0,0,1,.43.45v2.23a.44.44,0,0,1-.45.42Zm.09-4.44h0a.46.46,0,0,1-.44-.46l.05-2.22a.45.45,0,0,1,.89,0v2.22a.44.44,0,0,1-.5.46Zm.09-4.45h0a.44.44,0,0,1-.44-.45v-2.22A.46.46,0,0,1,233,203h0a.44.44,0,0,1,.43.45v2.23a.44.44,0,0,1-.51.44Zm188.81-1.59a.45.45,0,0,1-.45-.44v-2.22a.43.43,0,0,1,.44-.45h0a.45.45,0,0,1,.45.44v2.22a.44.44,0,0,1-.44.45ZM233,201.68h0a.44.44,0,0,1-.43-.45V199a.45.45,0,0,1,.89,0l-.05,2.22a.44.44,0,0,1-.41.46Zm188.69-1.6a.44.44,0,0,1-.44-.44v-2.22a.45.45,0,1,1,.89,0v2.23a.44.44,0,0,1-.44.44Zm-188.6-2.85h0a.44.44,0,0,1-.44-.45v-2.22a.46.46,0,0,1,.45-.44h0a.45.45,0,0,1,.43.46v2.22a.44.44,0,0,1-.44.43Zm188.57-1.59a.44.44,0,0,1-.44-.44v-2.23a.44.44,0,0,1,.44-.44h0a.44.44,0,0,1,.45.44v2.22A.45.45,0,0,1,421.66,195.64Zm-188.49-2.85h0a.44.44,0,0,1-.43-.45v-2.23a.44.44,0,0,1,.44-.43h0a.45.45,0,0,1,.44.45v2.22a.45.45,0,0,1-.45.44Zm188.46-1.6a.44.44,0,0,1-.45-.44v-2.22a.43.43,0,0,1,.44-.45h0a.46.46,0,0,1,.45.44v2.23A.44.44,0,0,1,421.63,191.19Zm-188.37-2.85h0a.44.44,0,0,1-.44-.45v-2.22a.46.46,0,0,1,.45-.44h0a.45.45,0,0,1,.43.46v2.22a.44.44,0,0,1-.44.43Zm188.33-1.59a.44.44,0,0,1-.44-.44v-2.23a.45.45,0,0,1,.89,0v2.22a.45.45,0,0,1-.44.45ZM233.34,183.9h0a.44.44,0,0,1-.43-.45v-2.22a.44.44,0,0,1,.45-.44.45.45,0,0,1,.44.45v2.22a.45.45,0,0,1-.46.44Zm188.22-1.6a.44.44,0,0,1-.44-.44v-2.22a.44.44,0,0,1,.44-.45h0a.45.45,0,0,1,.45.44v2.23a.43.43,0,0,1-.44.44Zm-188.13-2.84h0A.45.45,0,0,1,233,179v-2.22a.46.46,0,0,1,.46-.44.45.45,0,0,1,.43.46v2.22a.44.44,0,0,1-.46.44Zm188.1-1.6a.45.45,0,0,1-.45-.44v-2.23a.43.43,0,0,1,.44-.44h0a.44.44,0,0,1,.44.44v2.22a.44.44,0,0,1-.44.45Zm-188-2.85h0a.44.44,0,0,1-.43-.45v-2.22a.44.44,0,0,1,.44-.44h0a.45.45,0,0,1,.44.45v2.23a.45.45,0,0,1-.47.42Zm188-1.6a.44.44,0,0,1-.44-.44v-2.22a.45.45,0,0,1,.44-.45h0a.44.44,0,0,1,.44.44v2.22a.45.45,0,0,1-.44.45ZM233.6,170.57h0a.45.45,0,0,1-.44-.46v-2.22a.44.44,0,0,1,.44-.43h0a.43.43,0,0,1,.43.45v2.22A.44.44,0,0,1,233.6,170.57ZM421.46,169a.44.44,0,0,1-.44-.44v-2.23a.44.44,0,0,1,.44-.44h0a.44.44,0,0,1,.45.44v2.22a.43.43,0,0,1-.44.45Zm-187.78-2.85h0a.44.44,0,0,1-.43-.45v-2.22a.45.45,0,1,1,.89,0v2.23a.45.45,0,0,1-.46.41Zm187.75-1.6a.44.44,0,0,1-.45-.44v-2.22a.45.45,0,0,1,.45-.45h0a.44.44,0,0,1,.44.44v2.22a.44.44,0,0,1-.44.45Zm-187.66-2.84h0a.45.45,0,0,1-.44-.46l.05-2.22a.44.44,0,0,1,.44-.43h0a.43.43,0,0,1,.43.45v2.22a.44.44,0,0,1-.48.41Zm187.62-1.6a.44.44,0,0,1-.44-.44v-2.23a.44.44,0,0,1,.44-.44.43.43,0,0,1,.45.44v2.22a.45.45,0,0,1-.44.45Zm-187.54-2.85h0a.43.43,0,0,1-.43-.45v-2.22a.45.45,0,0,1,.45-.44h0a.45.45,0,0,1,.44.46v2.22a.45.45,0,0,1-.46.4Zm187.51-1.6a.45.45,0,0,1-.45-.44V153a.44.44,0,0,1,.44-.45h0a.45.45,0,0,1,.45.44v2.22a.43.43,0,0,1-.44.45Zm-187.42-2.84h0a.45.45,0,0,1-.44-.45v-2.23a.44.44,0,0,1,.44-.43h0a.45.45,0,0,1,.44.45l-.05,2.22a.44.44,0,0,1-.39.41Zm187.39-1.6a.45.45,0,0,1-.45-.44v-2.23a.45.45,0,0,1,.45-.44h0a.44.44,0,0,1,.44.44v2.22A.46.46,0,0,1,421.33,151.22ZM234,148.34h0a.43.43,0,0,1-.44-.45v-2.22a.45.45,0,0,1,.45-.44h0a.45.45,0,0,1,.44.46v2.22a.44.44,0,0,1-.45.43Zm187.27-1.6a.44.44,0,0,1-.44-.44v-2.22a.45.45,0,0,1,.44-.45h0a.44.44,0,0,1,.44.44v2.22a.45.45,0,0,1-.44.45ZM234.11,143.9h0a.46.46,0,0,1-.44-.45l.05-2.23a.44.44,0,0,1,.44-.43h0a.45.45,0,0,1,.44.45v2.22a.44.44,0,0,1-.49.44Zm187.15-1.6a.45.45,0,0,1-.45-.44v-2.23a.45.45,0,0,1,.44-.45.47.47,0,0,1,.45.45v2.22a.45.45,0,0,1-.44.45Zm-187.07-2.84h0a.45.45,0,0,1-.44-.46v-2.22a.46.46,0,0,1,.46-.44.45.45,0,0,1,.43.46v2.22a.45.45,0,0,1-.45.44Zm187-1.61a.45.45,0,0,1-.45-.44v-2.22a.45.45,0,0,1,.44-.45h0a.44.44,0,0,1,.44.44v2.22a.45.45,0,0,1-.44.45Zm-187-2.84h0a.44.44,0,0,1-.43-.45v-2.22a.44.44,0,0,1,.44-.44h0a.45.45,0,0,1,.44.45l-.05,2.22a.44.44,0,0,1-.31.43Zm186.91-1.6a.45.45,0,0,1-.44-.45v-2.22a.46.46,0,0,1,.44-.45h0a.45.45,0,0,1,.45.45v2.22A.46.46,0,0,1,421.1,133.41Zm-2-2.48H417a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0H399.2a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89H397a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H377a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89H357a.45.45,0,0,1,0,.89Zm-4.45,0H350.3a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H337a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89H317a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0H301.4a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H297a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89H277a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0H257a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0H252.5a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,1,1,0,.89Zm-4.44,0h-2.23a.45.45,0,0,1,0-.89h2.23a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,1,1,0-.89h2.22a.45.45,0,0,1,0,.89Zm-4.45,0h-2.22a.45.45,0,0,1,0-.89h2.22a.45.45,0,1,1,0,.89Z"
                    fill="#707272"
                />
                <path
                    id="Path_128"
                    data-name="Path 128"
                    d="M137.15,216.83H112.33a2.62,2.62,0,0,1-2.62-2.57l-2.24-108.91a2.61,2.61,0,0,1,2.81-2.67l27.06,1.95a2.63,2.63,0,0,1,2.44,2.62v107a2.62,2.62,0,0,1-2.63,2.58Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_129"
                    data-name="Path 129"
                    d="M113.57,147.07l.54,12.9a2.28,2.28,0,0,0,2.26,2.19l17.33.25a2.3,2.3,0,0,0,2.32-2.29v-12.9a2.29,2.29,0,0,0-2.26-2.29l-17.87-.25a2.31,2.31,0,0,0-2.32,2.39Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_130"
                    data-name="Path 130"
                    d="M133.76,164.37l-17.06-.24a2.29,2.29,0,0,0-2.32,2.39l.54,12.9a2.29,2.29,0,0,0,2.26,2.19l16.52.23a2.28,2.28,0,0,0,2.32-2.29V166.66a2.29,2.29,0,0,0-2.26-2.29Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_131"
                    data-name="Path 131"
                    d="M136,121.25v-9.71a2.29,2.29,0,0,0-2-2.27l-19.46-2.53a2.29,2.29,0,0,0-2.58,2.37l.5,12a2.28,2.28,0,0,0,2.25,2.19l19,.27a2.28,2.28,0,0,0,2.29-2.32Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_132"
                    data-name="Path 132"
                    d="M112.76,127.62l.54,12.9a2.29,2.29,0,0,0,2.25,2.2l18.15.25a2.28,2.28,0,0,0,2.32-2.29V127.79a2.29,2.29,0,0,0-2.26-2.29l-18.68-.26a2.29,2.29,0,0,0-2.32,2.38Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_133"
                    data-name="Path 133"
                    d="M115.19,186l.39,9.39a2.3,2.3,0,0,0,2.29,2.19h15.86a2.28,2.28,0,0,0,2.29-2.29v-9.16a2.29,2.29,0,0,0-2.26-2.29l-16.25-.22a2.29,2.29,0,0,0-2.32,2.38Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_134"
                    data-name="Path 134"
                    d="M139,215.4l-23.15,8.94a2.62,2.62,0,0,1-3.37-1.45L71.11,122.1a2.63,2.63,0,0,1,1.66-3.51l25.94-7.93a2.63,2.63,0,0,1,3.22,1.57L140.48,212A2.63,2.63,0,0,1,139,215.4Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_135"
                    data-name="Path 135"
                    d="M91.84,158.82,97,170.66a2.28,2.28,0,0,0,2.89,1.23l16.26-6a2.28,2.28,0,0,0,1.34-3l-4.65-12a2.3,2.3,0,0,0-2.93-1.32l-16.76,6.21a2.28,2.28,0,0,0-1.31,3.04Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_136"
                    data-name="Path 136"
                    d="M116.91,167.68l-16,5.93a2.29,2.29,0,0,0-1.3,3.06l5.15,11.84a2.3,2.3,0,0,0,2.9,1.23L123.14,184a2.28,2.28,0,0,0,1.34-3l-4.64-12a2.28,2.28,0,0,0-2.93-1.32Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_137"
                    data-name="Path 137"
                    d="M103.47,126.64l-3.5-9a2.27,2.27,0,0,0-2.68-1.4l-19.06,4.65A2.29,2.29,0,0,0,76.68,124l4.78,11a2.29,2.29,0,0,0,2.89,1.23l17.78-6.58a2.3,2.3,0,0,0,1.34-3.01Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_138"
                    data-name="Path 138"
                    d="M84.07,141l5.15,11.84a2.3,2.3,0,0,0,2.9,1.24l17-6.31a2.29,2.29,0,0,0,1.34-3l-4.65-12a2.3,2.3,0,0,0-2.93-1.32l-17.52,6.49A2.29,2.29,0,0,0,84.07,141Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_139"
                    data-name="Path 139"
                    d="M107.36,194.51l3.75,8.62a2.3,2.3,0,0,0,2.93,1.22l14.79-5.71a2.3,2.3,0,0,0,1.31-3l-3.3-8.54a2.28,2.28,0,0,0-2.93-1.32l-15.24,5.64a2.3,2.3,0,0,0-1.31,3.09Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_140"
                    data-name="Path 140"
                    d="M140.42,212.82l-15.86,19.09a2.63,2.63,0,0,1-3.66.38L35.7,164.42a2.62,2.62,0,0,1-.26-3.87L54.23,141a2.63,2.63,0,0,1,3.57-.2l82.28,68.35a2.62,2.62,0,0,1,.34,3.67Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_141"
                    data-name="Path 141"
                    d="M71.69,186.39,82,194.21a2.28,2.28,0,0,0,3.13-.33L96.35,180.7a2.29,2.29,0,0,0-.28-3.25l-9.92-8.24a2.29,2.29,0,0,0-3.2.28L71.34,183.08a2.28,2.28,0,0,0,.35,3.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_142"
                    data-name="Path 142"
                    d="M97.9,181.91l-11.09,13a2.29,2.29,0,0,0,.36,3.31L97.43,206a2.29,2.29,0,0,0,3.13-.34L111.3,193.1a2.29,2.29,0,0,0-.28-3.25l-9.92-8.24A2.28,2.28,0,0,0,97.9,181.91Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_143"
                    data-name="Path 143"
                    d="M66.17,152.62l-7.47-6.21a2.29,2.29,0,0,0-3,.09L41.3,159.85a2.28,2.28,0,0,0,.17,3.49L51,170.61a2.29,2.29,0,0,0,3.13-.33l12.32-14.42a2.28,2.28,0,0,0-.28-3.24Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_144"
                    data-name="Path 144"
                    d="M56.21,174.58l10.27,7.83a2.29,2.29,0,0,0,3.13-.33l11.79-13.8a2.29,2.29,0,0,0-.28-3.25L71.2,156.8a2.29,2.29,0,0,0-3.2.27l-12.14,14.2a2.3,2.3,0,0,0,.35,3.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_145"
                    data-name="Path 145"
                    d="M102.64,210l7.47,5.7a2.3,2.3,0,0,0,3.15-.36l10.14-12.2a2.31,2.31,0,0,0-.3-3.23l-7-5.85a2.29,2.29,0,0,0-3.2.27l-10.56,12.36a2.3,2.3,0,0,0,.3,3.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_146"
                    data-name="Path 146"
                    d="M79.75,221.59l61.62-.55a2.17,2.17,0,0,1,2.18,2.18l-.27,47.28a2.16,2.16,0,0,1-2.23,2.15c-11.14-.33-60.6-1.8-62.78-1.71s-1-37.89-.66-47.26A2.15,2.15,0,0,1,79.75,221.59Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_147"
                    data-name="Path 147"
                    d="M141.12,270.85h0c-8.86-.26-53.48-1.58-61.63-1.7H79.4v-.09c-.77-4.36-.76-22.14,0-45.31a.35.35,0,0,1,.36-.34l61.61-.56a.35.35,0,0,1,.26.11.32.32,0,0,1,.1.26l-.26,47.28A.38.38,0,0,1,141.12,270.85Zm-61.55-1.93c8.4.12,52.72,1.44,61.54,1.7h0a.13.13,0,0,0,.13-.13l.27-47.29a.11.11,0,0,0,0-.09.12.12,0,0,0-.1,0l-61.61.55a.13.13,0,0,0-.14.13c-.82,22.96-.84,40.64-.09,45.13Z"
                    fill="#707272"
                />
                <path
                    id="Path_148"
                    data-name="Path 148"
                    d="M73.58,387.69c3.21.15,6.31.06,8.38-.05-1.89-1.34-6.23-4.26-9.86-5.42l-2.5-.15a10.25,10.25,0,0,0-1.14,4.23C68.87,386.81,70.08,387.53,73.58,387.69Z"
                    fill="#707272"
                />
                <path
                    id="Path_149"
                    data-name="Path 149"
                    d="M82,387.66h0c-2.07.11-5.17.2-8.38.05-3.5-.16-4.71-.88-5.12-1.39v.41a1.17,1.17,0,0,0,.99,1.27c2.62.2,9.13.65,12.26.48a.43.43,0,0,0,.25-.82Z"
                    fill="#555656"
                />
                <path
                    id="Path_150"
                    data-name="Path 150"
                    d="M50.68,386.84a23.55,23.55,0,0,0-.9-4.23c-.46-.88-2,0-2,0a4.19,4.19,0,0,0-1.6,1.36c-.32.54-1.21,2.08-1.81,3.13a.65.65,0,0,0-.09.38l6.25.21a1.23,1.23,0,0,0,.15-.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_151"
                    data-name="Path 151"
                    d="M44.26,387.48a.71.71,0,0,0,.69.69l4.45.12a1.27,1.27,0,0,0,1.11-.6Z"
                    fill="#555656"
                />
                <path
                    id="Path_152"
                    data-name="Path 152"
                    d="M51.16,377.61c0,.18-.86,4.09-1.22,5.81a1,1,0,0,1-1,.78,4.082,4.082,0,0,1-.89-.07A1.2,1.2,0,0,1,47,383c-.06-1.51-.09-4.4.47-5.52C48.24,375.94,51.16,377.61,51.16,377.61Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_153"
                    data-name="Path 153"
                    d="M69.11,378.73c.35,0-.13,1.79.39,3.56a.91.91,0,0,0,.83.71,7.427,7.427,0,0,0,.92,0,1,1,0,0,0,.92-.9l.43-4.59Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_154"
                    data-name="Path 154"
                    d="M78.8,330c-.15.75-5.61,32.57-5.94,49a.57.57,0,0,1-.48.54,11,11,0,0,1-3.35,0,.39.39,0,0,1-.33-.36c-.19-3.07-1.72-29,.16-41.22,0,0-15.51,32.64-17.87,41.64a.47.47,0,0,1-.48.36,12.053,12.053,0,0,1-3.14-.56.82.82,0,0,1-.52-1c1.31-5.38,10.52-42.5,16.77-50.68Z"
                    fill="#555656"
                />
                <path
                    id="Path_155"
                    data-name="Path 155"
                    d="M68.86,338.16a.22.22,0,0,1-.15-.06.21.21,0,0,1,0-.29l2.08-2.12a.21.21,0,0,1,.29,0,.19.19,0,0,1,0,.28L69,338.1a.2.2,0,0,1-.14.06Z"
                    opacity="0.5"
                />
                <path
                    id="Path_156"
                    data-name="Path 156"
                    d="M98,290.13a19.7,19.7,0,0,1-10.31,0C83.15,289,74.2,287,68.11,288.09L67.6,304l20.83,2.38.19-4.23s12.66-1.83,19.51-10.16a33.468,33.468,0,0,1-3.83-5.18A16.329,16.329,0,0,1,98,290.13Z"
                    fill="#707272"
                />
                <path
                    id="Path_157"
                    data-name="Path 157"
                    d="M111.81,274.42l-1.61-.71s.08,8-5.9,13.13a33.468,33.468,0,0,0,3.83,5.18C111.51,287.92,113.47,282.24,111.81,274.42Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_158"
                    data-name="Path 158"
                    d="M78.08,279.23s-1.21,7.22-1.37,9.48c0,0,5.84,1.62,7.37.75l-.2-8.73Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_159"
                    data-name="Path 159"
                    d="M47.7,300.85l42.2-.34a2.1,2.1,0,0,1,2.1,2.13l-.21,28.42a2.12,2.12,0,0,1-2.18,2.1L48,331.63a2.12,2.12,0,0,1-2.05-2.09L45.6,303a2.12,2.12,0,0,1,2.1-2.15Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_160"
                    data-name="Path 160"
                    d="M89.7,331.35l-41.65-1.53a.29.29,0,0,1-.3-.3L47.41,303a.31.31,0,0,1,.09-.22.27.27,0,0,1,.21-.09l42.2-.35a.36.36,0,0,1,.22.09.31.31,0,0,1,.09.22L90,331.05a.3.3,0,0,1-.3.3Zm.21-28.81-42.2.34a.09.09,0,0,0-.06,0,.08.08,0,0,0,0,.06L48,329.52a.09.09,0,0,0,.08.08h0l41.65,1.53a.09.09,0,0,0,.08-.08L90,302.62a.09.09,0,0,0,0-.06.412.412,0,0,0-.09-.02Z"
                    fill="#707272"
                />
                <g id="Group_2" data-name="Group 2" opacity="0.5">
                    <path
                        id="Path_161"
                        data-name="Path 161"
                        d="M78.35,328.71a.64.64,0,0,1-.48-.22L76.62,327a10.071,10.071,0,0,1-2.74-.07l-1.33,1.42a.61.61,0,0,1-.71.15l-2.4-1.06a.62.62,0,0,1-.36-.63l.16-1.94a10.13,10.13,0,0,1-1.89-2l-1.94.07a.64.64,0,0,1-.61-.4l-.94-2.45a.64.64,0,0,1,.18-.7l1.49-1.25a10,10,0,0,1,.07-2.74l-1.42-1.33a.62.62,0,0,1-.15-.71l1.06-2.4a.64.64,0,0,1,.63-.37l1.94.17a10.131,10.131,0,0,1,2-1.89L69.57,307a.63.63,0,0,1,.4-.61l2.45-.94a.62.62,0,0,1,.7.18l1.25,1.49a9.66,9.66,0,0,1,2.74.07l1.33-1.43a.63.63,0,0,1,.71-.14l2.4,1.06a.64.64,0,0,1,.37.63l-.17,1.93a10.19,10.19,0,0,1,1.89,2l1.94-.07a.63.63,0,0,1,.61.4l.94,2.45a.62.62,0,0,1-.18.7l-1.49,1.25a9.681,9.681,0,0,1-.07,2.74L86.82,320a.62.62,0,0,1,.14.71l-1.06,2.4a.62.62,0,0,1-.63.36l-1.93-.16a10.19,10.19,0,0,1-2,1.89l.07,1.94a.63.63,0,0,1-.4.61l-2.45.94a.57.57,0,0,1-.21.02ZM77,326.06l1.45,1.71,2.09-.81-.08-2.24.21-.14a9.071,9.071,0,0,0,2.13-2l.15-.2,2.23.19.91-2.05L84.43,319v-.24a9.06,9.06,0,0,0,.07-2.94v-.24l1.71-1.45-.8-2.09-2.25.08-.13-.21a9.33,9.33,0,0,0-2-2.13l-.2-.15.19-2.23L79,306.46l-1.53,1.64-.24-.05a9.059,9.059,0,0,0-2.94-.07L74,308l-1.45-1.71-2.09.8.08,2.25-.2.13a9.169,9.169,0,0,0-2.14,2l-.14.2-2.24-.19-.91,2.05,1.64,1.53v.24a9.07,9.07,0,0,0-.08,2.94v.24L64.76,320l.81,2.09,2.24-.08.14.2a8.93,8.93,0,0,0,2,2.14l.2.14L70,326.7l2,.91L73.56,326h.24a9.07,9.07,0,0,0,2.94.08ZM80.55,327.15ZM86.23,320.63ZM64.8,313.44ZM85.38,311.83ZM70.48,306.92Zm5,16.87A6.75,6.75,0,1,1,82.14,316a.44.44,0,0,1-.37.51.45.45,0,0,1-.51-.37,5.69,5.69,0,0,0-.32-1.21,5.828,5.828,0,1,0-.88,5.73.445.445,0,0,1,.7.55,6.81,6.81,0,0,1-2.9,2.15,6.91,6.91,0,0,1-2.41.43Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_162"
                        data-name="Path 162"
                        d="M75.5,319.81a2.77,2.77,0,0,1-1.6-5,2.72,2.72,0,0,1,2.1-.51,2.78,2.78,0,0,1,1.79,1.13h0a2.73,2.73,0,0,1,.47,2.07,2.77,2.77,0,0,1-2.73,2.31Zm0-4.66a1.92,1.92,0,0,0-1.08.34,1.925,1.925,0,1,0,1.36-.26Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_163"
                        data-name="Path 163"
                        d="M56.11,316.89h0l-1.25-.15a.43.43,0,0,1-.36-.33l-.18-.85a4.931,4.931,0,0,1-1.07-.61l-.82.29a.44.44,0,0,1-.47-.14l-.77-1a.42.42,0,0,1,0-.48l.48-.73a4.94,4.94,0,0,1-.33-1.18l-.78-.39a.42.42,0,0,1-.23-.42l.15-1.26a.44.44,0,0,1,.33-.36l.86-.18a4.45,4.45,0,0,1,.6-1.06l-.28-.83a.39.39,0,0,1,.14-.46l1-.78a.42.42,0,0,1,.49,0l.73.47a5.283,5.283,0,0,1,1.18-.32l.38-.79a.42.42,0,0,1,.43-.23l1.25.16a.41.41,0,0,1,.36.33l.18.85a5.339,5.339,0,0,1,1.07.6l.82-.28a.42.42,0,0,1,.47.14l.77,1a.42.42,0,0,1,0,.49l-.47.73a4.39,4.39,0,0,1,.32,1.18l.79.38a.43.43,0,0,1,.23.43l-.15,1.25a.43.43,0,0,1-.33.36l-.86.19a5.06,5.06,0,0,1-.6,1.06l.28.82a.42.42,0,0,1-.14.47l-1,.78a.42.42,0,0,1-.49,0l-.73-.48a4.809,4.809,0,0,1-1.18.33l-.38.78a.42.42,0,0,1-.44.22ZM55.11,316.26Zm0-.17.91.11.46-.95h.19a4.06,4.06,0,0,0,1.32-.37l.17-.07.89.57.71-.56-.34-1,.12-.14a4.16,4.16,0,0,0,.67-1.2l.07-.17,1-.22.11-.9-1-.47v-.18a4.39,4.39,0,0,0-.37-1.33L60,309l.58-.88-.56-.72-1,.34-.15-.11a4.271,4.271,0,0,0-1.19-.68l-.18-.07-.22-1-.9-.11-.46.95h-.19a4.309,4.309,0,0,0-1.32.36l-.17.08-.89-.58-.72.56.35,1-.12.15a4.19,4.19,0,0,0-.68,1.2l-.06.17-1,.22-.11.9,1,.47v.18a4.39,4.39,0,0,0,.37,1.33l.08.16-.58.89.56.72,1-.34.14.11a4.321,4.321,0,0,0,1.2.68l.17.06ZM52.49,314.68ZM61.49,312.03Zm-10.37-2.32ZM60.7,308.27ZM60.7,307.99ZM52.53,307.26ZM57.28,305.7Zm-1.08,8.66a3,3,0,0,1-.42,0,3.38,3.38,0,1,1,3.08-5.43,3,3,0,0,1,.38.61.38.38,0,0,1-.69.3,3.06,3.06,0,0,0-.3-.49,2.72,2.72,0,0,0-1.81-1,2.66,2.66,0,0,0-2,.55,2.714,2.714,0,1,0,4.22,3.12.32.32,0,0,1,.43-.19.33.33,0,0,1,.19.43,3.39,3.39,0,0,1-1.08,1.44,3.32,3.32,0,0,1-2.07.66Z"
                        fill="#707272"
                    />
                </g>
                <path
                    id="Path_164"
                    data-name="Path 164"
                    d="M73.22,296.69l-5.11-8.6S57.42,297.25,54.19,310l5.67,3.56C62.18,309.39,66.24,303.86,73.22,296.69Z"
                    fill="#707272"
                />
                <path
                    id="Path_165"
                    data-name="Path 165"
                    d="M62.16,332.15c-.65,0-1.16-.1-1.43-.69a43.63,43.63,0,0,0-2-3.93.3.3,0,0,1,.2-.46,3.57,3.57,0,0,1,1.38.07,1.94,1.94,0,0,0,2.07-.51.3.3,0,0,0-.14-.44L57.19,324a.29.29,0,0,1-.18-.19c-.23-.82-.68-3.88,2.7-10a.3.3,0,0,0-.1-.41l-5.06-3.18a.3.3,0,0,0-.46.18,26.91,26.91,0,0,0,.55,15.08h0c.06.37,1.13,6.24,3.23,7.46s5.51-.78,5.51-.78Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_166"
                    data-name="Path 166"
                    d="M84.64,272.58s2,4.46,2.08,6.8.63,3.86-2.08,4.33a5.76,5.76,0,0,1-6.22-3.21s-1.93-3.59-1.5-5.06S84.64,272.58,84.64,272.58Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_167"
                    data-name="Path 167"
                    d="M79.35,278.83h.34s-1.41-2.9-.17-3.4,6.14-1.51,7.2-3.25a3.25,3.25,0,0,0-1.25-4.46.19.19,0,0,0-.23.09l-.11.21a.18.18,0,0,1-.34,0h0a.18.18,0,0,0-.33-.05c-.33.52-1.2,1.37-3.56,1.8-3.34.62-5.54,2-5.6,4.27a.19.19,0,0,1-.28.16c-.25-.15-.64-.23-1.17.22-.92.77-.54,2.77,1.47,4.41a.19.19,0,0,1,0,.3c-.37.24-.91.8.5,1.55a3.78,3.78,0,0,0,2.61.61.19.19,0,0,0,.14-.19l-.13-2.1a.18.18,0,0,1,.18-.19Z"
                    fill="#555656"
                />
                <path
                    id="Path_168"
                    data-name="Path 168"
                    d="M79.43,279.25s-.74-2.84-2-2.05.67,3.2,1.69,3.3Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_169"
                    data-name="Path 169"
                    d="M105.77,267.73V271s2.62,3.33,6,3.47c0,0,3-.2,2.9-2.43l-4.81-.92a22.327,22.327,0,0,1-2.58-.9S106.91,267.83,105.77,267.73Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_170"
                    data-name="Path 170"
                    d="M87.19,264.79h40.39a1.63,1.63,0,0,0,1.4-2.45l-16-27.19a1.63,1.63,0,0,0-2.88.15l-7.72,16.92a1.63,1.63,0,0,1-2.58.53l-3.12-2.87a1.63,1.63,0,0,0-2.44.27l-8.4,12.08a1.63,1.63,0,0,0,1.35,2.56Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_4"
                    data-name="Ellipse 4"
                    cx="5.81"
                    cy="5.81"
                    r="5.81"
                    transform="translate(121.22 228.52)"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_171"
                    data-name="Path 171"
                    d="M316.59,153a12.1,12.1,0,0,1,7.41,2.52l4.34-6.15A19.4,19.4,0,0,0,317,145.69a10.517,10.517,0,0,0-1.68.09l1.12,7.2Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_172"
                    data-name="Path 172"
                    d="M316.59,177.33c-6.73,0-13.56-5-13.56-11.74s6.73-12.53,13.41-12.61l-1.12-7.2c-10.17.91-20,9.89-20,20.07,0,10.75,10.92,18.75,21.66,18.75a19.34,19.34,0,0,0,7.91-1.68l-4.37-6.25A12.3,12.3,0,0,1,316.59,177.33Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_173"
                    data-name="Path 173"
                    d="M336.46,165.15a19.458,19.458,0,0,0-8.116-15.807L324,155.49a12.17,12.17,0,0,1-3.46,21.18l4.37,6.25A19.45,19.45,0,0,0,336.46,165.15Z"
                    fill="#555656"
                />
                <path
                    id="Path_174"
                    data-name="Path 174"
                    d="M372.11,153a12.16,12.16,0,0,1,10.9,6.76l5-6.32a19.42,19.42,0,0,0-15.51-7.72,22.45,22.45,0,0,0-13.92,5.25l4.45,5.61a14.13,14.13,0,0,1,9.08-3.58Z"
                    fill="#555656"
                />
                <path
                    id="Path_175"
                    data-name="Path 175"
                    d="M358.55,165.59a12.24,12.24,0,0,1,4.5-9l-4.45-5.61c-4.58,3.75-7.74,9.14-7.74,14.91,0,10.61,10.64,18.54,21.25,18.74l-.34-7.27C365.16,177.15,358.55,172.2,358.55,165.59Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_176"
                    data-name="Path 176"
                    d="M372.11,177.33h-.34l.34,7.27h.41A19.45,19.45,0,0,0,389.83,174c-1.86-.84-4.62-2-7-3.07a12.18,12.18,0,0,1-10.72,6.4Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_177"
                    data-name="Path 177"
                    d="M388,153.41l-5,6.32a12.23,12.23,0,0,1-.19,11.22c2.39,1,5.15,2.23,7,3.07a19.46,19.46,0,0,0-1.8-20.61Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_178"
                    data-name="Path 178"
                    d="M427.63,153a12.18,12.18,0,0,1,7,2.2l3.92-6.4A19.4,19.4,0,0,0,428,145.69a22.5,22.5,0,0,0-14.32,5.59l4.66,5.43a14.2,14.2,0,0,1,9.29-3.71Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_179"
                    data-name="Path 179"
                    d="M439.78,164.45l7.58-1.53a19.45,19.45,0,0,0-8.83-14.15l-3.92,6.4a12.18,12.18,0,0,1,5.17,9.28Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_180"
                    data-name="Path 180"
                    d="M414.07,165.59a12.19,12.19,0,0,1,4.31-8.88l-4.66-5.43c-4.37,3.73-7.34,9-7.34,14.57,0,7,4.58,12.77,10.73,16l3.81-6.18C417,173.67,414.07,170,414.07,165.59Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_181"
                    data-name="Path 181"
                    d="M439.78,164.45v.7a12.18,12.18,0,0,1-12.17,12.18,14.8,14.8,0,0,1-6.71-1.66l-3.81,6.18A23.68,23.68,0,0,0,428,184.6a19.45,19.45,0,0,0,19.45-19.45,20.386,20.386,0,0,0-.13-2.23Z"
                    fill="#555656"
                />
                <path
                    id="Path_182"
                    data-name="Path 182"
                    d="M333.29,99.53l-72.7-.41a3.82,3.82,0,0,0-3.29,5.78l.37.61a3.81,3.81,0,0,0,3.27,1.85h72.32a3.82,3.82,0,0,0,3.82-3.81v-.21A3.82,3.82,0,0,0,333.29,99.53Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_183"
                    data-name="Path 183"
                    d="M343.44,103.43v.12a3.82,3.82,0,0,0,3.81,3.81h16.14a3.82,3.82,0,0,0,3.69-2.831h0a3.82,3.82,0,0,0-3.66-4.8l-16.14-.12a3.82,3.82,0,0,0-3.84,3.82Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_184"
                    data-name="Path 184"
                    d="M315.8,113.23l-55.21-.41a3.82,3.82,0,0,0-3.29,5.78l.37.61a3.81,3.81,0,0,0,3.27,1.85h54.84a3.81,3.81,0,0,0,3.81-3.82V117A3.8,3.8,0,0,0,315.8,113.23Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_185"
                    data-name="Path 185"
                    d="M326,117.13v.11a3.82,3.82,0,0,0,3.82,3.82h16.14a3.81,3.81,0,0,0,3.68-2.83h0a3.81,3.81,0,0,0-3.66-4.8l-16.13-.12a3.82,3.82,0,0,0-3.85,3.82Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_186"
                    data-name="Path 186"
                    d="M226.24,136a1.17,1.17,0,0,0-.82.33l-16,15.2a7.44,7.44,0,0,1-5.14,2.05H149.59a1.19,1.19,0,0,0,0,2.37h54.64a9.81,9.81,0,0,0,6.77-2.7l16.05-15.21a1.18,1.18,0,0,0-.81-2Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_187"
                    data-name="Path 187"
                    d="M195.84,160.94H149.59a1.19,1.19,0,0,0,0,2.37h46.25a1.19,1.19,0,0,0,0-2.37Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_188"
                    data-name="Path 188"
                    d="M188.31,168.28H149.59a1.18,1.18,0,1,0,0,2.36h38.72a1.18,1.18,0,0,0,0-2.36Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_5"
                    data-name="Ellipse 5"
                    cx="11.32"
                    cy="11.32"
                    r="11.32"
                    transform="translate(420.98 66.01)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_6"
                    data-name="Ellipse 6"
                    cx="9.62"
                    cy="9.62"
                    r="9.62"
                    transform="translate(21.34 206.1)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_189"
                    data-name="Path 189"
                    d="M482,178.05h-5.22v-5.21a.65.65,0,0,0-.65-.65h0a.66.66,0,0,0-.66.65v5.21h-5.21a.66.66,0,0,0-.65.66.65.65,0,0,0,.65.65h5.21v5.22a.66.66,0,0,0,.66.65.65.65,0,0,0,.65-.65h0v-5.22H482a.66.66,0,0,0,0-1.31Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_190"
                    data-name="Path 190"
                    d="M51.78,96.14h-8.4V87.75a1,1,0,0,0-1.05-1h0a1.08,1.08,0,0,0-1.07,1v8.39H32.89a1.06,1.06,0,1,0,0,2.11h8.37v8.4a1.07,1.07,0,0,0,1.07,1,1,1,0,0,0,1.05-1h0v-8.4h8.4a1.06,1.06,0,0,0,0-2.11Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_191"
                    data-name="Path 191"
                    d="M190.66,112.11H185v-5.62a.7.7,0,0,0-.7-.7h0a.7.7,0,0,0-.71.7v5.62H178a.71.71,0,0,0,0,1.41h5.62v5.63a.705.705,0,0,0,1.41,0h0v-5.63h5.63a.71.71,0,0,0,0-1.41Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
            </g>
        </SVGIcon>
    );
}
